var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1631,
    height: 1357,
    viewBox: "0 0 1631 1357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_2728_79987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1280.7 350L1137.7 673.5H682.698L348.198 1008",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 1006.2,
    r: 50,
    transform: "rotate(180 350 1006.2)",
    fill: "url(#paint0_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.802,
    cy: 1004.4,
    r: 50,
    transform: "rotate(180 351.802 1004.4)",
    fill: "url(#paint1_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.604,
    cy: 1002.59,
    r: 50,
    transform: "rotate(180 353.604 1002.59)",
    fill: "url(#paint2_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.406,
    cy: 1000.79,
    r: 50,
    transform: "rotate(180 355.406 1000.79)",
    fill: "url(#paint3_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.207,
    cy: 998.99,
    r: 50,
    transform: "rotate(180 357.207 998.99)",
    fill: "url(#paint4_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.01,
    cy: 997.188,
    r: 50,
    transform: "rotate(180 359.01 997.188)",
    fill: "url(#paint5_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.811,
    cy: 995.387,
    r: 50,
    transform: "rotate(180 360.811 995.387)",
    fill: "url(#paint6_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.613,
    cy: 993.585,
    r: 50,
    transform: "rotate(180 362.613 993.585)",
    fill: "url(#paint7_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.415,
    cy: 991.783,
    r: 50,
    transform: "rotate(180 364.415 991.783)",
    fill: "url(#paint8_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.217,
    cy: 989.981,
    r: 50,
    transform: "rotate(180 366.217 989.981)",
    fill: "url(#paint9_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.019,
    cy: 988.18,
    r: 50,
    transform: "rotate(180 368.019 988.18)",
    fill: "url(#paint10_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.82,
    cy: 986.378,
    r: 50,
    transform: "rotate(180 369.82 986.378)",
    fill: "url(#paint11_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.623,
    cy: 984.576,
    r: 50,
    transform: "rotate(180 371.623 984.576)",
    fill: "url(#paint12_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.424,
    cy: 982.774,
    r: 50,
    transform: "rotate(180 373.424 982.774)",
    fill: "url(#paint13_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.227,
    cy: 980.972,
    r: 50,
    transform: "rotate(180 375.227 980.972)",
    fill: "url(#paint14_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.027,
    cy: 979.17,
    r: 50,
    transform: "rotate(180 377.027 979.17)",
    fill: "url(#paint15_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.83,
    cy: 977.368,
    r: 50,
    transform: "rotate(180 378.83 977.368)",
    fill: "url(#paint16_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.632,
    cy: 975.566,
    r: 50,
    transform: "rotate(180 380.632 975.566)",
    fill: "url(#paint17_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.434,
    cy: 973.765,
    r: 50,
    transform: "rotate(180 382.434 973.765)",
    fill: "url(#paint18_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.235,
    cy: 971.963,
    r: 50,
    transform: "rotate(180 384.235 971.963)",
    fill: "url(#paint19_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.037,
    cy: 970.161,
    r: 50,
    transform: "rotate(180 386.037 970.161)",
    fill: "url(#paint20_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.84,
    cy: 968.359,
    r: 50,
    transform: "rotate(180 387.84 968.359)",
    fill: "url(#paint21_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.641,
    cy: 966.558,
    r: 50,
    transform: "rotate(180 389.641 966.558)",
    fill: "url(#paint22_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.443,
    cy: 964.756,
    r: 50,
    transform: "rotate(180 391.443 964.756)",
    fill: "url(#paint23_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.244,
    cy: 962.953,
    r: 50,
    transform: "rotate(180 393.244 962.953)",
    fill: "url(#paint24_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.047,
    cy: 961.151,
    r: 50,
    transform: "rotate(180 395.047 961.151)",
    fill: "url(#paint25_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.849,
    cy: 959.35,
    r: 50,
    transform: "rotate(180 396.849 959.35)",
    fill: "url(#paint26_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.65,
    cy: 957.548,
    r: 50,
    transform: "rotate(180 398.65 957.548)",
    fill: "url(#paint27_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.452,
    cy: 955.746,
    r: 50,
    transform: "rotate(180 400.452 955.746)",
    fill: "url(#paint28_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.254,
    cy: 953.944,
    r: 50,
    transform: "rotate(180 402.254 953.944)",
    fill: "url(#paint29_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.056,
    cy: 952.143,
    r: 50,
    transform: "rotate(180 404.056 952.143)",
    fill: "url(#paint30_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.857,
    cy: 950.341,
    r: 50,
    transform: "rotate(180 405.857 950.341)",
    fill: "url(#paint31_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.66,
    cy: 948.539,
    r: 50,
    transform: "rotate(180 407.66 948.539)",
    fill: "url(#paint32_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.461,
    cy: 946.736,
    r: 50,
    transform: "rotate(180 409.461 946.736)",
    fill: "url(#paint33_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.264,
    cy: 944.935,
    r: 50,
    transform: "rotate(180 411.264 944.935)",
    fill: "url(#paint34_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.064,
    cy: 943.133,
    r: 50,
    transform: "rotate(180 413.064 943.133)",
    fill: "url(#paint35_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.867,
    cy: 941.331,
    r: 50,
    transform: "rotate(180 414.867 941.331)",
    fill: "url(#paint36_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.669,
    cy: 939.529,
    r: 50,
    transform: "rotate(180 416.669 939.529)",
    fill: "url(#paint37_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.471,
    cy: 937.728,
    r: 50,
    transform: "rotate(180 418.471 937.728)",
    fill: "url(#paint38_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.272,
    cy: 935.926,
    r: 50,
    transform: "rotate(180 420.272 935.926)",
    fill: "url(#paint39_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.074,
    cy: 934.124,
    r: 50,
    transform: "rotate(180 422.074 934.124)",
    fill: "url(#paint40_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.877,
    cy: 932.322,
    r: 50,
    transform: "rotate(180 423.877 932.322)",
    fill: "url(#paint41_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.678,
    cy: 930.521,
    r: 50,
    transform: "rotate(180 425.678 930.521)",
    fill: "url(#paint42_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.48,
    cy: 928.718,
    r: 50,
    transform: "rotate(180 427.48 928.718)",
    fill: "url(#paint43_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429.281,
    cy: 926.916,
    r: 50,
    transform: "rotate(180 429.281 926.916)",
    fill: "url(#paint44_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.084,
    cy: 925.114,
    r: 50,
    transform: "rotate(180 431.084 925.114)",
    fill: "url(#paint45_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.886,
    cy: 923.312,
    r: 50,
    transform: "rotate(180 432.886 923.312)",
    fill: "url(#paint46_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.688,
    cy: 921.511,
    r: 50,
    transform: "rotate(180 434.688 921.511)",
    fill: "url(#paint47_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.489,
    cy: 919.709,
    r: 50,
    transform: "rotate(180 436.489 919.709)",
    fill: "url(#paint48_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.291,
    cy: 917.907,
    r: 50,
    transform: "rotate(180 438.291 917.907)",
    fill: "url(#paint49_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440.094,
    cy: 916.105,
    r: 50,
    transform: "rotate(180 440.094 916.105)",
    fill: "url(#paint50_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.895,
    cy: 914.304,
    r: 50,
    transform: "rotate(180 441.895 914.304)",
    fill: "url(#paint51_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.697,
    cy: 912.502,
    r: 50,
    transform: "rotate(180 443.697 912.502)",
    fill: "url(#paint52_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.498,
    cy: 910.699,
    r: 50,
    transform: "rotate(180 445.498 910.699)",
    fill: "url(#paint53_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.301,
    cy: 908.897,
    r: 50,
    transform: "rotate(180 447.301 908.897)",
    fill: "url(#paint54_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.103,
    cy: 907.096,
    r: 50,
    transform: "rotate(180 449.103 907.096)",
    fill: "url(#paint55_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.904,
    cy: 905.294,
    r: 50,
    transform: "rotate(180 450.904 905.294)",
    fill: "url(#paint56_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452.706,
    cy: 903.492,
    r: 50,
    transform: "rotate(180 452.706 903.492)",
    fill: "url(#paint57_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.508,
    cy: 901.69,
    r: 50,
    transform: "rotate(180 454.508 901.69)",
    fill: "url(#paint58_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456.31,
    cy: 899.889,
    r: 50,
    transform: "rotate(180 456.31 899.889)",
    fill: "url(#paint59_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458.111,
    cy: 898.087,
    r: 50,
    transform: "rotate(180 458.111 898.087)",
    fill: "url(#paint60_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.914,
    cy: 896.285,
    r: 50,
    transform: "rotate(180 459.914 896.285)",
    fill: "url(#paint61_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 461.715,
    cy: 894.483,
    r: 50,
    transform: "rotate(180 461.715 894.483)",
    fill: "url(#paint62_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.518,
    cy: 892.681,
    r: 50,
    transform: "rotate(180 463.518 892.681)",
    fill: "url(#paint63_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.318,
    cy: 890.879,
    r: 50,
    transform: "rotate(180 465.318 890.879)",
    fill: "url(#paint64_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.121,
    cy: 889.077,
    r: 50,
    transform: "rotate(180 467.121 889.077)",
    fill: "url(#paint65_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.923,
    cy: 887.275,
    r: 50,
    transform: "rotate(180 468.923 887.275)",
    fill: "url(#paint66_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.725,
    cy: 885.474,
    r: 50,
    transform: "rotate(180 470.725 885.474)",
    fill: "url(#paint67_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.526,
    cy: 883.672,
    r: 50,
    transform: "rotate(180 472.526 883.672)",
    fill: "url(#paint68_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474.328,
    cy: 881.87,
    r: 50,
    transform: "rotate(180 474.328 881.87)",
    fill: "url(#paint69_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.131,
    cy: 880.068,
    r: 50,
    transform: "rotate(180 476.131 880.068)",
    fill: "url(#paint70_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.932,
    cy: 878.267,
    r: 50,
    transform: "rotate(180 477.932 878.267)",
    fill: "url(#paint71_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.734,
    cy: 876.464,
    r: 50,
    transform: "rotate(180 479.734 876.464)",
    fill: "url(#paint72_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.535,
    cy: 874.662,
    r: 50,
    transform: "rotate(180 481.535 874.662)",
    fill: "url(#paint73_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.338,
    cy: 872.86,
    r: 50,
    transform: "rotate(180 483.338 872.86)",
    fill: "url(#paint74_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.14,
    cy: 871.059,
    r: 50,
    transform: "rotate(180 485.14 871.059)",
    fill: "url(#paint75_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.941,
    cy: 869.257,
    r: 50,
    transform: "rotate(180 486.941 869.257)",
    fill: "url(#paint76_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.743,
    cy: 867.455,
    r: 50,
    transform: "rotate(180 488.743 867.455)",
    fill: "url(#paint77_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.545,
    cy: 865.653,
    r: 50,
    transform: "rotate(180 490.545 865.653)",
    fill: "url(#paint78_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.347,
    cy: 863.852,
    r: 50,
    transform: "rotate(180 492.347 863.852)",
    fill: "url(#paint79_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 494.148,
    cy: 862.05,
    r: 50,
    transform: "rotate(180 494.148 862.05)",
    fill: "url(#paint80_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.951,
    cy: 860.248,
    r: 50,
    transform: "rotate(180 495.951 860.248)",
    fill: "url(#paint81_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.752,
    cy: 858.445,
    r: 50,
    transform: "rotate(180 497.752 858.445)",
    fill: "url(#paint82_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.555,
    cy: 856.644,
    r: 50,
    transform: "rotate(180 499.555 856.644)",
    fill: "url(#paint83_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501.356,
    cy: 854.842,
    r: 50,
    transform: "rotate(180 501.356 854.842)",
    fill: "url(#paint84_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.158,
    cy: 853.04,
    r: 50,
    transform: "rotate(180 503.158 853.04)",
    fill: "url(#paint85_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504.96,
    cy: 851.238,
    r: 50,
    transform: "rotate(180 504.96 851.238)",
    fill: "url(#paint86_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.762,
    cy: 849.437,
    r: 50,
    transform: "rotate(180 506.762 849.437)",
    fill: "url(#paint87_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 508.563,
    cy: 847.635,
    r: 50,
    transform: "rotate(180 508.563 847.635)",
    fill: "url(#paint88_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510.365,
    cy: 845.833,
    r: 50,
    transform: "rotate(180 510.365 845.833)",
    fill: "url(#paint89_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512.168,
    cy: 844.031,
    r: 50,
    transform: "rotate(180 512.168 844.031)",
    fill: "url(#paint90_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.969,
    cy: 842.229,
    r: 50,
    transform: "rotate(180 513.969 842.229)",
    fill: "url(#paint91_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 515.771,
    cy: 840.427,
    r: 50,
    transform: "rotate(180 515.771 840.427)",
    fill: "url(#paint92_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 517.572,
    cy: 838.625,
    r: 50,
    transform: "rotate(180 517.572 838.625)",
    fill: "url(#paint93_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.375,
    cy: 836.823,
    r: 50,
    transform: "rotate(180 519.375 836.823)",
    fill: "url(#paint94_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521.177,
    cy: 835.021,
    r: 50,
    transform: "rotate(180 521.177 835.021)",
    fill: "url(#paint95_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522.979,
    cy: 833.22,
    r: 50,
    transform: "rotate(180 522.979 833.22)",
    fill: "url(#paint96_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.78,
    cy: 831.418,
    r: 50,
    transform: "rotate(180 524.78 831.418)",
    fill: "url(#paint97_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 526.582,
    cy: 829.616,
    r: 50,
    transform: "rotate(180 526.582 829.616)",
    fill: "url(#paint98_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.385,
    cy: 827.814,
    r: 50,
    transform: "rotate(180 528.385 827.814)",
    fill: "url(#paint99_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.186,
    cy: 826.013,
    r: 50,
    transform: "rotate(180 530.186 826.013)",
    fill: "url(#paint100_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.988,
    cy: 824.21,
    r: 50,
    transform: "rotate(180 531.988 824.21)",
    fill: "url(#paint101_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.789,
    cy: 822.408,
    r: 50,
    transform: "rotate(180 533.789 822.408)",
    fill: "url(#paint102_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 535.592,
    cy: 820.606,
    r: 50,
    transform: "rotate(180 535.592 820.606)",
    fill: "url(#paint103_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.394,
    cy: 818.805,
    r: 50,
    transform: "rotate(180 537.394 818.805)",
    fill: "url(#paint104_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.195,
    cy: 817.003,
    r: 50,
    transform: "rotate(180 539.195 817.003)",
    fill: "url(#paint105_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.997,
    cy: 815.201,
    r: 50,
    transform: "rotate(180 540.997 815.201)",
    fill: "url(#paint106_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.799,
    cy: 813.399,
    r: 50,
    transform: "rotate(180 542.799 813.399)",
    fill: "url(#paint107_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 544.601,
    cy: 811.598,
    r: 50,
    transform: "rotate(180 544.601 811.598)",
    fill: "url(#paint108_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546.402,
    cy: 809.796,
    r: 50,
    transform: "rotate(180 546.402 809.796)",
    fill: "url(#paint109_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.205,
    cy: 807.994,
    r: 50,
    transform: "rotate(180 548.205 807.994)",
    fill: "url(#paint110_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 550.006,
    cy: 806.191,
    r: 50,
    transform: "rotate(180 550.006 806.191)",
    fill: "url(#paint111_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.809,
    cy: 804.39,
    r: 50,
    transform: "rotate(180 551.809 804.39)",
    fill: "url(#paint112_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.61,
    cy: 802.588,
    r: 50,
    transform: "rotate(180 553.61 802.588)",
    fill: "url(#paint113_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555.412,
    cy: 800.786,
    r: 50,
    transform: "rotate(180 555.412 800.786)",
    fill: "url(#paint114_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.214,
    cy: 798.984,
    r: 50,
    transform: "rotate(180 557.214 798.984)",
    fill: "url(#paint115_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.016,
    cy: 797.183,
    r: 50,
    transform: "rotate(180 559.016 797.183)",
    fill: "url(#paint116_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.817,
    cy: 795.381,
    r: 50,
    transform: "rotate(180 560.817 795.381)",
    fill: "url(#paint117_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.619,
    cy: 793.579,
    r: 50,
    transform: "rotate(180 562.619 793.579)",
    fill: "url(#paint118_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.422,
    cy: 791.777,
    r: 50,
    transform: "rotate(180 564.422 791.777)",
    fill: "url(#paint119_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.223,
    cy: 789.976,
    r: 50,
    transform: "rotate(180 566.223 789.976)",
    fill: "url(#paint120_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568.025,
    cy: 788.173,
    r: 50,
    transform: "rotate(180 568.025 788.173)",
    fill: "url(#paint121_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.826,
    cy: 786.371,
    r: 50,
    transform: "rotate(180 569.826 786.371)",
    fill: "url(#paint122_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 571.629,
    cy: 784.569,
    r: 50,
    transform: "rotate(180 571.629 784.569)",
    fill: "url(#paint123_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 573.431,
    cy: 782.768,
    r: 50,
    transform: "rotate(180 573.431 782.768)",
    fill: "url(#paint124_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.232,
    cy: 780.966,
    r: 50,
    transform: "rotate(180 575.232 780.966)",
    fill: "url(#paint125_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.034,
    cy: 779.164,
    r: 50,
    transform: "rotate(180 577.034 779.164)",
    fill: "url(#paint126_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.836,
    cy: 777.362,
    r: 50,
    transform: "rotate(180 578.836 777.362)",
    fill: "url(#paint127_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.639,
    cy: 775.561,
    r: 50,
    transform: "rotate(180 580.639 775.561)",
    fill: "url(#paint128_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.439,
    cy: 773.759,
    r: 50,
    transform: "rotate(180 582.439 773.759)",
    fill: "url(#paint129_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 584.242,
    cy: 771.956,
    r: 50,
    transform: "rotate(180 584.242 771.956)",
    fill: "url(#paint130_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.043,
    cy: 770.154,
    r: 50,
    transform: "rotate(180 586.043 770.154)",
    fill: "url(#paint131_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 587.846,
    cy: 768.353,
    r: 50,
    transform: "rotate(180 587.846 768.353)",
    fill: "url(#paint132_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589.647,
    cy: 766.551,
    r: 50,
    transform: "rotate(180 589.647 766.551)",
    fill: "url(#paint133_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.449,
    cy: 764.749,
    r: 50,
    transform: "rotate(180 591.449 764.749)",
    fill: "url(#paint134_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.251,
    cy: 762.947,
    r: 50,
    transform: "rotate(180 593.251 762.947)",
    fill: "url(#paint135_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.053,
    cy: 761.146,
    r: 50,
    transform: "rotate(180 595.053 761.146)",
    fill: "url(#paint136_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 596.854,
    cy: 759.344,
    r: 50,
    transform: "rotate(180 596.854 759.344)",
    fill: "url(#paint137_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598.656,
    cy: 757.542,
    r: 50,
    transform: "rotate(180 598.656 757.542)",
    fill: "url(#paint138_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600.459,
    cy: 755.74,
    r: 50,
    transform: "rotate(180 600.459 755.74)",
    fill: "url(#paint139_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602.26,
    cy: 753.938,
    r: 50,
    transform: "rotate(180 602.26 753.938)",
    fill: "url(#paint140_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.062,
    cy: 752.136,
    r: 50,
    transform: "rotate(180 604.062 752.136)",
    fill: "url(#paint141_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 605.863,
    cy: 750.334,
    r: 50,
    transform: "rotate(180 605.863 750.334)",
    fill: "url(#paint142_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 607.666,
    cy: 748.532,
    r: 50,
    transform: "rotate(180 607.666 748.532)",
    fill: "url(#paint143_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 609.468,
    cy: 746.73,
    r: 50,
    transform: "rotate(180 609.468 746.73)",
    fill: "url(#paint144_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 611.27,
    cy: 744.929,
    r: 50,
    transform: "rotate(180 611.27 744.929)",
    fill: "url(#paint145_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 613.071,
    cy: 743.127,
    r: 50,
    transform: "rotate(180 613.071 743.127)",
    fill: "url(#paint146_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 614.873,
    cy: 741.325,
    r: 50,
    transform: "rotate(180 614.873 741.325)",
    fill: "url(#paint147_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 616.676,
    cy: 739.523,
    r: 50,
    transform: "rotate(180 616.676 739.523)",
    fill: "url(#paint148_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618.477,
    cy: 737.722,
    r: 50,
    transform: "rotate(180 618.477 737.722)",
    fill: "url(#paint149_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.279,
    cy: 735.919,
    r: 50,
    transform: "rotate(180 620.279 735.919)",
    fill: "url(#paint150_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.08,
    cy: 734.117,
    r: 50,
    transform: "rotate(180 622.08 734.117)",
    fill: "url(#paint151_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.883,
    cy: 732.315,
    r: 50,
    transform: "rotate(180 623.883 732.315)",
    fill: "url(#paint152_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.685,
    cy: 730.514,
    r: 50,
    transform: "rotate(180 625.685 730.514)",
    fill: "url(#paint153_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 627.486,
    cy: 728.712,
    r: 50,
    transform: "rotate(180 627.486 728.712)",
    fill: "url(#paint154_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 629.288,
    cy: 726.91,
    r: 50,
    transform: "rotate(180 629.288 726.91)",
    fill: "url(#paint155_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 631.09,
    cy: 725.108,
    r: 50,
    transform: "rotate(180 631.09 725.108)",
    fill: "url(#paint156_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 632.893,
    cy: 723.307,
    r: 50,
    transform: "rotate(180 632.893 723.307)",
    fill: "url(#paint157_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634.693,
    cy: 721.505,
    r: 50,
    transform: "rotate(180 634.693 721.505)",
    fill: "url(#paint158_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 636.496,
    cy: 719.703,
    r: 50,
    transform: "rotate(180 636.496 719.703)",
    fill: "url(#paint159_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 638.297,
    cy: 717.9,
    r: 50,
    transform: "rotate(180 638.297 717.9)",
    fill: "url(#paint160_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640.1,
    cy: 716.099,
    r: 50,
    transform: "rotate(180 640.1 716.099)",
    fill: "url(#paint161_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 641.901,
    cy: 714.297,
    r: 50,
    transform: "rotate(180 641.901 714.297)",
    fill: "url(#paint162_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.703,
    cy: 712.495,
    r: 50,
    transform: "rotate(180 643.703 712.495)",
    fill: "url(#paint163_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.505,
    cy: 710.693,
    r: 50,
    transform: "rotate(180 645.505 710.693)",
    fill: "url(#paint164_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 647.307,
    cy: 708.892,
    r: 50,
    transform: "rotate(180 647.307 708.892)",
    fill: "url(#paint165_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 649.108,
    cy: 707.09,
    r: 50,
    transform: "rotate(180 649.108 707.09)",
    fill: "url(#paint166_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650.91,
    cy: 705.288,
    r: 50,
    transform: "rotate(180 650.91 705.288)",
    fill: "url(#paint167_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652.713,
    cy: 703.486,
    r: 50,
    transform: "rotate(180 652.713 703.486)",
    fill: "url(#paint168_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 654.514,
    cy: 701.684,
    r: 50,
    transform: "rotate(180 654.514 701.684)",
    fill: "url(#paint169_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.316,
    cy: 699.882,
    r: 50,
    transform: "rotate(180 656.316 699.882)",
    fill: "url(#paint170_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658.117,
    cy: 698.08,
    r: 50,
    transform: "rotate(180 658.117 698.08)",
    fill: "url(#paint171_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 659.92,
    cy: 696.278,
    r: 50,
    transform: "rotate(180 659.92 696.278)",
    fill: "url(#paint172_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 661.722,
    cy: 694.477,
    r: 50,
    transform: "rotate(180 661.722 694.477)",
    fill: "url(#paint173_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.523,
    cy: 692.675,
    r: 50,
    transform: "rotate(180 663.523 692.675)",
    fill: "url(#paint174_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 665.325,
    cy: 690.873,
    r: 50,
    transform: "rotate(180 665.325 690.873)",
    fill: "url(#paint175_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 667.127,
    cy: 689.071,
    r: 50,
    transform: "rotate(180 667.127 689.071)",
    fill: "url(#paint176_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 668.93,
    cy: 687.27,
    r: 50,
    transform: "rotate(180 668.93 687.27)",
    fill: "url(#paint177_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 670.73,
    cy: 685.468,
    r: 50,
    transform: "rotate(180 670.73 685.468)",
    fill: "url(#paint178_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 672.533,
    cy: 683.665,
    r: 50,
    transform: "rotate(180 672.533 683.665)",
    fill: "url(#paint179_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674.334,
    cy: 681.863,
    r: 50,
    transform: "rotate(180 674.334 681.863)",
    fill: "url(#paint180_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676.137,
    cy: 680.062,
    r: 50,
    transform: "rotate(180 676.137 680.062)",
    fill: "url(#paint181_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 677.938,
    cy: 678.26,
    r: 50,
    transform: "rotate(180 677.938 678.26)",
    fill: "url(#paint182_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.74,
    cy: 676.458,
    r: 50,
    transform: "rotate(180 679.74 676.458)",
    fill: "url(#paint183_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 681.542,
    cy: 674.656,
    r: 50,
    transform: "rotate(180 681.542 674.656)",
    fill: "url(#paint184_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 683.611,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 683.611 673.5)",
    fill: "url(#paint185_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686.16,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 686.16 673.5)",
    fill: "url(#paint186_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.708,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 688.708 673.5)",
    fill: "url(#paint187_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 691.256,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 691.256 673.5)",
    fill: "url(#paint188_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 693.805,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 693.805 673.5)",
    fill: "url(#paint189_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.353,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 696.353 673.5)",
    fill: "url(#paint190_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698.9,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 698.9 673.5)",
    fill: "url(#paint191_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 701.449,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 701.449 673.5)",
    fill: "url(#paint192_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 703.997,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 703.997 673.5)",
    fill: "url(#paint193_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706.545,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 706.545 673.5)",
    fill: "url(#paint194_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 709.094,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 709.094 673.5)",
    fill: "url(#paint195_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 711.642,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 711.642 673.5)",
    fill: "url(#paint196_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.189,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 714.189 673.5)",
    fill: "url(#paint197_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 716.738,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 716.738 673.5)",
    fill: "url(#paint198_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 719.286,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 719.286 673.5)",
    fill: "url(#paint199_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 721.834,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 721.834 673.5)",
    fill: "url(#paint200_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 724.383,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 724.383 673.5)",
    fill: "url(#paint201_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 726.932,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 726.932 673.5)",
    fill: "url(#paint202_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 729.479,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 729.479 673.5)",
    fill: "url(#paint203_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.027,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 732.027 673.5)",
    fill: "url(#paint204_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 734.576,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 734.576 673.5)",
    fill: "url(#paint205_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 737.124,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 737.124 673.5)",
    fill: "url(#paint206_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 739.672,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 739.672 673.5)",
    fill: "url(#paint207_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 742.221,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 742.221 673.5)",
    fill: "url(#paint208_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 744.769,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 744.769 673.5)",
    fill: "url(#paint209_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 747.316,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 747.316 673.5)",
    fill: "url(#paint210_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.865,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 749.865 673.5)",
    fill: "url(#paint211_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 752.413,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 752.413 673.5)",
    fill: "url(#paint212_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.961,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 754.961 673.5)",
    fill: "url(#paint213_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 757.51,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 757.51 673.5)",
    fill: "url(#paint214_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 760.058,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 760.058 673.5)",
    fill: "url(#paint215_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.605,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 762.605 673.5)",
    fill: "url(#paint216_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.154,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 765.154 673.5)",
    fill: "url(#paint217_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.702,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 767.702 673.5)",
    fill: "url(#paint218_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770.25,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 770.25 673.5)",
    fill: "url(#paint219_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 772.799,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 772.799 673.5)",
    fill: "url(#paint220_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775.348,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 775.348 673.5)",
    fill: "url(#paint221_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 777.895,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 777.895 673.5)",
    fill: "url(#paint222_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 780.443,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 780.443 673.5)",
    fill: "url(#paint223_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 782.992,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 782.992 673.5)",
    fill: "url(#paint224_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 785.54,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 785.54 673.5)",
    fill: "url(#paint225_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 788.088,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 788.088 673.5)",
    fill: "url(#paint226_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 790.637,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 790.637 673.5)",
    fill: "url(#paint227_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 793.185,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 793.185 673.5)",
    fill: "url(#paint228_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 795.732,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 795.732 673.5)",
    fill: "url(#paint229_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 798.281,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 798.281 673.5)",
    fill: "url(#paint230_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800.829,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 800.829 673.5)",
    fill: "url(#paint231_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 803.377,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 803.377 673.5)",
    fill: "url(#paint232_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 805.926,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 805.926 673.5)",
    fill: "url(#paint233_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.474,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 808.474 673.5)",
    fill: "url(#paint234_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 811.021,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 811.021 673.5)",
    fill: "url(#paint235_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 813.57,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 813.57 673.5)",
    fill: "url(#paint236_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 816.119,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 816.119 673.5)",
    fill: "url(#paint237_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818.666,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 818.666 673.5)",
    fill: "url(#paint238_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 821.215,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 821.215 673.5)",
    fill: "url(#paint239_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 823.764,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 823.764 673.5)",
    fill: "url(#paint240_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826.311,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 826.311 673.5)",
    fill: "url(#paint241_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.859,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 828.859 673.5)",
    fill: "url(#paint242_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 831.408,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 831.408 673.5)",
    fill: "url(#paint243_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 833.956,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 833.956 673.5)",
    fill: "url(#paint244_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 836.504,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 836.504 673.5)",
    fill: "url(#paint245_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.053,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 839.053 673.5)",
    fill: "url(#paint246_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 841.601,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 841.601 673.5)",
    fill: "url(#paint247_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844.148,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 844.148 673.5)",
    fill: "url(#paint248_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.697,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 846.697 673.5)",
    fill: "url(#paint249_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 849.245,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 849.245 673.5)",
    fill: "url(#paint250_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 851.793,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 851.793 673.5)",
    fill: "url(#paint251_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854.342,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 854.342 673.5)",
    fill: "url(#paint252_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856.89,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 856.89 673.5)",
    fill: "url(#paint253_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 859.438,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 859.438 673.5)",
    fill: "url(#paint254_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861.986,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 861.986 673.5)",
    fill: "url(#paint255_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 864.535,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 864.535 673.5)",
    fill: "url(#paint256_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 867.082,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 867.082 673.5)",
    fill: "url(#paint257_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 869.631,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 869.631 673.5)",
    fill: "url(#paint258_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 872.18,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 872.18 673.5)",
    fill: "url(#paint259_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874.728,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 874.728 673.5)",
    fill: "url(#paint260_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.275,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 877.275 673.5)",
    fill: "url(#paint261_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 879.824,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 879.824 673.5)",
    fill: "url(#paint262_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882.372,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 882.372 673.5)",
    fill: "url(#paint263_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 884.92,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 884.92 673.5)",
    fill: "url(#paint264_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 887.469,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 887.469 673.5)",
    fill: "url(#paint265_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890.017,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 890.017 673.5)",
    fill: "url(#paint266_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892.564,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 892.564 673.5)",
    fill: "url(#paint267_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 895.113,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 895.113 673.5)",
    fill: "url(#paint268_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 897.661,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 897.661 673.5)",
    fill: "url(#paint269_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900.209,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 900.209 673.5)",
    fill: "url(#paint270_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 902.758,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 902.758 673.5)",
    fill: "url(#paint271_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.306,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 905.306 673.5)",
    fill: "url(#paint272_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 907.854,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 907.854 673.5)",
    fill: "url(#paint273_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 910.402,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 910.402 673.5)",
    fill: "url(#paint274_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 912.951,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 912.951 673.5)",
    fill: "url(#paint275_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 915.498,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 915.498 673.5)",
    fill: "url(#paint276_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.047,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 918.047 673.5)",
    fill: "url(#paint277_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 920.596,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 920.596 673.5)",
    fill: "url(#paint278_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 923.144,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 923.144 673.5)",
    fill: "url(#paint279_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 925.691,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 925.691 673.5)",
    fill: "url(#paint280_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928.24,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 928.24 673.5)",
    fill: "url(#paint281_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930.788,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 930.788 673.5)",
    fill: "url(#paint282_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 933.336,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 933.336 673.5)",
    fill: "url(#paint283_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 935.885,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 935.885 673.5)",
    fill: "url(#paint284_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938.433,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 938.433 673.5)",
    fill: "url(#paint285_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940.98,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 940.98 673.5)",
    fill: "url(#paint286_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 943.529,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 943.529 673.5)",
    fill: "url(#paint287_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.077,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 946.077 673.5)",
    fill: "url(#paint288_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948.625,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 948.625 673.5)",
    fill: "url(#paint289_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 951.174,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 951.174 673.5)",
    fill: "url(#paint290_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 953.722,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 953.722 673.5)",
    fill: "url(#paint291_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 956.27,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 956.27 673.5)",
    fill: "url(#paint292_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 958.818,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 958.818 673.5)",
    fill: "url(#paint293_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.367,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 961.367 673.5)",
    fill: "url(#paint294_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963.914,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 963.914 673.5)",
    fill: "url(#paint295_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 966.463,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 966.463 673.5)",
    fill: "url(#paint296_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 969.012,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 969.012 673.5)",
    fill: "url(#paint297_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 971.56,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 971.56 673.5)",
    fill: "url(#paint298_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 974.107,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 974.107 673.5)",
    fill: "url(#paint299_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976.656,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 976.656 673.5)",
    fill: "url(#paint300_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 979.204,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 979.204 673.5)",
    fill: "url(#paint301_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 981.752,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 981.752 673.5)",
    fill: "url(#paint302_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 984.301,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 984.301 673.5)",
    fill: "url(#paint303_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 986.849,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 986.849 673.5)",
    fill: "url(#paint304_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 989.396,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 989.396 673.5)",
    fill: "url(#paint305_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 991.945,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 991.945 673.5)",
    fill: "url(#paint306_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994.493,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 994.493 673.5)",
    fill: "url(#paint307_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 997.041,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 997.041 673.5)",
    fill: "url(#paint308_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 999.59,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 999.59 673.5)",
    fill: "url(#paint309_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1002.14,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1002.14 673.5)",
    fill: "url(#paint310_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.69,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1004.69 673.5)",
    fill: "url(#paint311_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1007.23,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1007.23 673.5)",
    fill: "url(#paint312_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1009.78,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1009.78 673.5)",
    fill: "url(#paint313_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012.33,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1012.33 673.5)",
    fill: "url(#paint314_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1014.88,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1014.88 673.5)",
    fill: "url(#paint315_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1017.43,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1017.43 673.5)",
    fill: "url(#paint316_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019.98,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1019.98 673.5)",
    fill: "url(#paint317_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1022.52,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1022.52 673.5)",
    fill: "url(#paint318_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1025.07,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1025.07 673.5)",
    fill: "url(#paint319_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.62,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1027.62 673.5)",
    fill: "url(#paint320_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1030.17,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1030.17 673.5)",
    fill: "url(#paint321_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1032.72,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1032.72 673.5)",
    fill: "url(#paint322_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.26,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1035.26 673.5)",
    fill: "url(#paint323_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1037.81,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1037.81 673.5)",
    fill: "url(#paint324_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040.36,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1040.36 673.5)",
    fill: "url(#paint325_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042.91,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1042.91 673.5)",
    fill: "url(#paint326_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1045.46,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1045.46 673.5)",
    fill: "url(#paint327_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048.01,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1048.01 673.5)",
    fill: "url(#paint328_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050.55,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1050.55 673.5)",
    fill: "url(#paint329_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1053.1,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1053.1 673.5)",
    fill: "url(#paint330_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1055.65,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1055.65 673.5)",
    fill: "url(#paint331_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1058.2,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1058.2 673.5)",
    fill: "url(#paint332_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.75,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1060.75 673.5)",
    fill: "url(#paint333_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1063.29,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1063.29 673.5)",
    fill: "url(#paint334_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1065.84,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1065.84 673.5)",
    fill: "url(#paint335_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1068.39,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1068.39 673.5)",
    fill: "url(#paint336_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1070.94,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1070.94 673.5)",
    fill: "url(#paint337_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1073.49,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1073.49 673.5)",
    fill: "url(#paint338_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1076.04,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1076.04 673.5)",
    fill: "url(#paint339_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1078.58,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1078.58 673.5)",
    fill: "url(#paint340_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1081.13,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1081.13 673.5)",
    fill: "url(#paint341_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1083.68,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1083.68 673.5)",
    fill: "url(#paint342_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1086.23,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1086.23 673.5)",
    fill: "url(#paint343_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1088.78,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1088.78 673.5)",
    fill: "url(#paint344_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1091.33,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1091.33 673.5)",
    fill: "url(#paint345_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1093.87,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1093.87 673.5)",
    fill: "url(#paint346_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1096.42,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1096.42 673.5)",
    fill: "url(#paint347_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1098.97,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1098.97 673.5)",
    fill: "url(#paint348_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1101.52,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1101.52 673.5)",
    fill: "url(#paint349_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1104.07,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1104.07 673.5)",
    fill: "url(#paint350_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1106.62,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1106.62 673.5)",
    fill: "url(#paint351_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1109.16,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1109.16 673.5)",
    fill: "url(#paint352_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1111.71,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1111.71 673.5)",
    fill: "url(#paint353_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.26,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1114.26 673.5)",
    fill: "url(#paint354_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1116.81,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1116.81 673.5)",
    fill: "url(#paint355_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1119.36,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1119.36 673.5)",
    fill: "url(#paint356_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1121.9,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1121.9 673.5)",
    fill: "url(#paint357_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1124.45,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1124.45 673.5)",
    fill: "url(#paint358_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1127 673.5)",
    fill: "url(#paint359_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1129.55,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1129.55 673.5)",
    fill: "url(#paint360_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1132.1,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1132.1 673.5)",
    fill: "url(#paint361_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1134.64,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1134.64 673.5)",
    fill: "url(#paint362_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1137.19,
    cy: 673.5,
    r: 50,
    transform: "rotate(180 1137.19 673.5)",
    fill: "url(#paint363_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1138.52,
    cy: 671.631,
    r: 50,
    transform: "rotate(180 1138.52 671.631)",
    fill: "url(#paint364_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1139.55,
    cy: 669.301,
    r: 50,
    transform: "rotate(180 1139.55 669.301)",
    fill: "url(#paint365_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1140.58,
    cy: 666.97,
    r: 50,
    transform: "rotate(180 1140.58 666.97)",
    fill: "url(#paint366_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1141.62,
    cy: 664.64,
    r: 50,
    transform: "rotate(180 1141.62 664.64)",
    fill: "url(#paint367_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1142.65,
    cy: 662.309,
    r: 50,
    transform: "rotate(180 1142.65 662.309)",
    fill: "url(#paint368_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1143.68,
    cy: 659.978,
    r: 50,
    transform: "rotate(180 1143.68 659.978)",
    fill: "url(#paint369_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1144.71,
    cy: 657.647,
    r: 50,
    transform: "rotate(180 1144.71 657.647)",
    fill: "url(#paint370_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1145.74,
    cy: 655.316,
    r: 50,
    transform: "rotate(180 1145.74 655.316)",
    fill: "url(#paint371_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1146.77,
    cy: 652.986,
    r: 50,
    transform: "rotate(180 1146.77 652.986)",
    fill: "url(#paint372_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1147.8,
    cy: 650.655,
    r: 50,
    transform: "rotate(180 1147.8 650.655)",
    fill: "url(#paint373_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1148.83,
    cy: 648.324,
    r: 50,
    transform: "rotate(180 1148.83 648.324)",
    fill: "url(#paint374_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1149.86,
    cy: 645.994,
    r: 50,
    transform: "rotate(180 1149.86 645.994)",
    fill: "url(#paint375_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1150.89,
    cy: 643.663,
    r: 50,
    transform: "rotate(180 1150.89 643.663)",
    fill: "url(#paint376_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1151.92,
    cy: 641.333,
    r: 50,
    transform: "rotate(180 1151.92 641.333)",
    fill: "url(#paint377_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1152.95,
    cy: 639.002,
    r: 50,
    transform: "rotate(180 1152.95 639.002)",
    fill: "url(#paint378_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1153.98,
    cy: 636.671,
    r: 50,
    transform: "rotate(180 1153.98 636.671)",
    fill: "url(#paint379_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1155.01,
    cy: 634.341,
    r: 50,
    transform: "rotate(180 1155.01 634.341)",
    fill: "url(#paint380_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1156.04,
    cy: 632.01,
    r: 50,
    transform: "rotate(180 1156.04 632.01)",
    fill: "url(#paint381_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1157.07,
    cy: 629.68,
    r: 50,
    transform: "rotate(180 1157.07 629.68)",
    fill: "url(#paint382_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1158.1,
    cy: 627.349,
    r: 50,
    transform: "rotate(180 1158.1 627.349)",
    fill: "url(#paint383_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1159.13,
    cy: 625.018,
    r: 50,
    transform: "rotate(180 1159.13 625.018)",
    fill: "url(#paint384_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.16,
    cy: 622.688,
    r: 50,
    transform: "rotate(180 1160.16 622.688)",
    fill: "url(#paint385_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.19,
    cy: 620.356,
    r: 50,
    transform: "rotate(180 1161.19 620.356)",
    fill: "url(#paint386_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.22,
    cy: 618.026,
    r: 50,
    transform: "rotate(180 1162.22 618.026)",
    fill: "url(#paint387_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1163.25,
    cy: 615.695,
    r: 50,
    transform: "rotate(180 1163.25 615.695)",
    fill: "url(#paint388_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1164.28,
    cy: 613.364,
    r: 50,
    transform: "rotate(180 1164.28 613.364)",
    fill: "url(#paint389_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1165.31,
    cy: 611.034,
    r: 50,
    transform: "rotate(180 1165.31 611.034)",
    fill: "url(#paint390_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1166.34,
    cy: 608.703,
    r: 50,
    transform: "rotate(180 1166.34 608.703)",
    fill: "url(#paint391_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1167.37,
    cy: 606.373,
    r: 50,
    transform: "rotate(180 1167.37 606.373)",
    fill: "url(#paint392_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1168.4,
    cy: 604.042,
    r: 50,
    transform: "rotate(180 1168.4 604.042)",
    fill: "url(#paint393_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169.43,
    cy: 601.711,
    r: 50,
    transform: "rotate(180 1169.43 601.711)",
    fill: "url(#paint394_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170.46,
    cy: 599.381,
    r: 50,
    transform: "rotate(180 1170.46 599.381)",
    fill: "url(#paint395_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1171.49,
    cy: 597.05,
    r: 50,
    transform: "rotate(180 1171.49 597.05)",
    fill: "url(#paint396_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1172.52,
    cy: 594.72,
    r: 50,
    transform: "rotate(180 1172.52 594.72)",
    fill: "url(#paint397_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1173.55,
    cy: 592.389,
    r: 50,
    transform: "rotate(180 1173.55 592.389)",
    fill: "url(#paint398_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1174.58,
    cy: 590.058,
    r: 50,
    transform: "rotate(180 1174.58 590.058)",
    fill: "url(#paint399_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1175.61,
    cy: 587.728,
    r: 50,
    transform: "rotate(180 1175.61 587.728)",
    fill: "url(#paint400_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1176.64,
    cy: 585.396,
    r: 50,
    transform: "rotate(180 1176.64 585.396)",
    fill: "url(#paint401_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1177.67,
    cy: 583.066,
    r: 50,
    transform: "rotate(180 1177.67 583.066)",
    fill: "url(#paint402_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1178.7,
    cy: 580.735,
    r: 50,
    transform: "rotate(180 1178.7 580.735)",
    fill: "url(#paint403_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1179.73,
    cy: 578.405,
    r: 50,
    transform: "rotate(180 1179.73 578.405)",
    fill: "url(#paint404_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180.76,
    cy: 576.074,
    r: 50,
    transform: "rotate(180 1180.76 576.074)",
    fill: "url(#paint405_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1181.79,
    cy: 573.743,
    r: 50,
    transform: "rotate(180 1181.79 573.743)",
    fill: "url(#paint406_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1182.82,
    cy: 571.413,
    r: 50,
    transform: "rotate(180 1182.82 571.413)",
    fill: "url(#paint407_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1183.86,
    cy: 569.082,
    r: 50,
    transform: "rotate(180 1183.86 569.082)",
    fill: "url(#paint408_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1184.88,
    cy: 566.752,
    r: 50,
    transform: "rotate(180 1184.88 566.752)",
    fill: "url(#paint409_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1185.92,
    cy: 564.421,
    r: 50,
    transform: "rotate(180 1185.92 564.421)",
    fill: "url(#paint410_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1186.95,
    cy: 562.09,
    r: 50,
    transform: "rotate(180 1186.95 562.09)",
    fill: "url(#paint411_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1187.98,
    cy: 559.76,
    r: 50,
    transform: "rotate(180 1187.98 559.76)",
    fill: "url(#paint412_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1189.01,
    cy: 557.429,
    r: 50,
    transform: "rotate(180 1189.01 557.429)",
    fill: "url(#paint413_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1190.04,
    cy: 555.099,
    r: 50,
    transform: "rotate(180 1190.04 555.099)",
    fill: "url(#paint414_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1191.07,
    cy: 552.768,
    r: 50,
    transform: "rotate(180 1191.07 552.768)",
    fill: "url(#paint415_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1192.1,
    cy: 550.437,
    r: 50,
    transform: "rotate(180 1192.1 550.437)",
    fill: "url(#paint416_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.13,
    cy: 548.106,
    r: 50,
    transform: "rotate(180 1193.13 548.106)",
    fill: "url(#paint417_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1194.16,
    cy: 545.775,
    r: 50,
    transform: "rotate(180 1194.16 545.775)",
    fill: "url(#paint418_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1195.19,
    cy: 543.445,
    r: 50,
    transform: "rotate(180 1195.19 543.445)",
    fill: "url(#paint419_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1196.22,
    cy: 541.114,
    r: 50,
    transform: "rotate(180 1196.22 541.114)",
    fill: "url(#paint420_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1197.25,
    cy: 538.783,
    r: 50,
    transform: "rotate(180 1197.25 538.783)",
    fill: "url(#paint421_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1198.28,
    cy: 536.453,
    r: 50,
    transform: "rotate(180 1198.28 536.453)",
    fill: "url(#paint422_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1199.31,
    cy: 534.122,
    r: 50,
    transform: "rotate(180 1199.31 534.122)",
    fill: "url(#paint423_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1200.34,
    cy: 531.792,
    r: 50,
    transform: "rotate(180 1200.34 531.792)",
    fill: "url(#paint424_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.37,
    cy: 529.461,
    r: 50,
    transform: "rotate(180 1201.37 529.461)",
    fill: "url(#paint425_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1202.4,
    cy: 527.13,
    r: 50,
    transform: "rotate(180 1202.4 527.13)",
    fill: "url(#paint426_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1203.43,
    cy: 524.8,
    r: 50,
    transform: "rotate(180 1203.43 524.8)",
    fill: "url(#paint427_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1204.46,
    cy: 522.469,
    r: 50,
    transform: "rotate(180 1204.46 522.469)",
    fill: "url(#paint428_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1205.49,
    cy: 520.139,
    r: 50,
    transform: "rotate(180 1205.49 520.139)",
    fill: "url(#paint429_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1206.52,
    cy: 517.808,
    r: 50,
    transform: "rotate(180 1206.52 517.808)",
    fill: "url(#paint430_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1207.55,
    cy: 515.477,
    r: 50,
    transform: "rotate(180 1207.55 515.477)",
    fill: "url(#paint431_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1208.58,
    cy: 513.146,
    r: 50,
    transform: "rotate(180 1208.58 513.146)",
    fill: "url(#paint432_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1209.61,
    cy: 510.815,
    r: 50,
    transform: "rotate(180 1209.61 510.815)",
    fill: "url(#paint433_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1210.64,
    cy: 508.485,
    r: 50,
    transform: "rotate(180 1210.64 508.485)",
    fill: "url(#paint434_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1211.67,
    cy: 506.154,
    r: 50,
    transform: "rotate(180 1211.67 506.154)",
    fill: "url(#paint435_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1212.7,
    cy: 503.823,
    r: 50,
    transform: "rotate(180 1212.7 503.823)",
    fill: "url(#paint436_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1213.73,
    cy: 501.493,
    r: 50,
    transform: "rotate(180 1213.73 501.493)",
    fill: "url(#paint437_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214.76,
    cy: 499.162,
    r: 50,
    transform: "rotate(180 1214.76 499.162)",
    fill: "url(#paint438_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215.79,
    cy: 496.832,
    r: 50,
    transform: "rotate(180 1215.79 496.832)",
    fill: "url(#paint439_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1216.82,
    cy: 494.501,
    r: 50,
    transform: "rotate(180 1216.82 494.501)",
    fill: "url(#paint440_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1217.85,
    cy: 492.17,
    r: 50,
    transform: "rotate(180 1217.85 492.17)",
    fill: "url(#paint441_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1218.88,
    cy: 489.84,
    r: 50,
    transform: "rotate(180 1218.88 489.84)",
    fill: "url(#paint442_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1219.91,
    cy: 487.509,
    r: 50,
    transform: "rotate(180 1219.91 487.509)",
    fill: "url(#paint443_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1220.94,
    cy: 485.179,
    r: 50,
    transform: "rotate(180 1220.94 485.179)",
    fill: "url(#paint444_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1221.97,
    cy: 482.848,
    r: 50,
    transform: "rotate(180 1221.97 482.848)",
    fill: "url(#paint445_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1223,
    cy: 480.517,
    r: 50,
    transform: "rotate(180 1223 480.517)",
    fill: "url(#paint446_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1224.04,
    cy: 478.187,
    r: 50,
    transform: "rotate(180 1224.04 478.187)",
    fill: "url(#paint447_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1225.06,
    cy: 475.855,
    r: 50,
    transform: "rotate(180 1225.06 475.855)",
    fill: "url(#paint448_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1226.1,
    cy: 473.525,
    r: 50,
    transform: "rotate(180 1226.1 473.525)",
    fill: "url(#paint449_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1227.12,
    cy: 471.194,
    r: 50,
    transform: "rotate(180 1227.12 471.194)",
    fill: "url(#paint450_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1228.16,
    cy: 468.863,
    r: 50,
    transform: "rotate(180 1228.16 468.863)",
    fill: "url(#paint451_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1229.19,
    cy: 466.533,
    r: 50,
    transform: "rotate(180 1229.19 466.533)",
    fill: "url(#paint452_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1230.22,
    cy: 464.202,
    r: 50,
    transform: "rotate(180 1230.22 464.202)",
    fill: "url(#paint453_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1231.25,
    cy: 461.872,
    r: 50,
    transform: "rotate(180 1231.25 461.872)",
    fill: "url(#paint454_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1232.28,
    cy: 459.541,
    r: 50,
    transform: "rotate(180 1232.28 459.541)",
    fill: "url(#paint455_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1233.31,
    cy: 457.21,
    r: 50,
    transform: "rotate(180 1233.31 457.21)",
    fill: "url(#paint456_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1234.34,
    cy: 454.88,
    r: 50,
    transform: "rotate(180 1234.34 454.88)",
    fill: "url(#paint457_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1235.37,
    cy: 452.549,
    r: 50,
    transform: "rotate(180 1235.37 452.549)",
    fill: "url(#paint458_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1236.4,
    cy: 450.219,
    r: 50,
    transform: "rotate(180 1236.4 450.219)",
    fill: "url(#paint459_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1237.43,
    cy: 447.888,
    r: 50,
    transform: "rotate(180 1237.43 447.888)",
    fill: "url(#paint460_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1238.46,
    cy: 445.557,
    r: 50,
    transform: "rotate(180 1238.46 445.557)",
    fill: "url(#paint461_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1239.49,
    cy: 443.227,
    r: 50,
    transform: "rotate(180 1239.49 443.227)",
    fill: "url(#paint462_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1240.52,
    cy: 440.896,
    r: 50,
    transform: "rotate(180 1240.52 440.896)",
    fill: "url(#paint463_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.55,
    cy: 438.565,
    r: 50,
    transform: "rotate(180 1241.55 438.565)",
    fill: "url(#paint464_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1242.58,
    cy: 436.234,
    r: 50,
    transform: "rotate(180 1242.58 436.234)",
    fill: "url(#paint465_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1243.61,
    cy: 433.903,
    r: 50,
    transform: "rotate(180 1243.61 433.903)",
    fill: "url(#paint466_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1244.64,
    cy: 431.573,
    r: 50,
    transform: "rotate(180 1244.64 431.573)",
    fill: "url(#paint467_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1245.67,
    cy: 429.242,
    r: 50,
    transform: "rotate(180 1245.67 429.242)",
    fill: "url(#paint468_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1246.7,
    cy: 426.912,
    r: 50,
    transform: "rotate(180 1246.7 426.912)",
    fill: "url(#paint469_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1247.73,
    cy: 424.581,
    r: 50,
    transform: "rotate(180 1247.73 424.581)",
    fill: "url(#paint470_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1248.76,
    cy: 422.251,
    r: 50,
    transform: "rotate(180 1248.76 422.251)",
    fill: "url(#paint471_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1249.79,
    cy: 419.92,
    r: 50,
    transform: "rotate(180 1249.79 419.92)",
    fill: "url(#paint472_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1250.82,
    cy: 417.589,
    r: 50,
    transform: "rotate(180 1250.82 417.589)",
    fill: "url(#paint473_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1251.85,
    cy: 415.259,
    r: 50,
    transform: "rotate(180 1251.85 415.259)",
    fill: "url(#paint474_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1252.88,
    cy: 412.928,
    r: 50,
    transform: "rotate(180 1252.88 412.928)",
    fill: "url(#paint475_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1253.91,
    cy: 410.598,
    r: 50,
    transform: "rotate(180 1253.91 410.598)",
    fill: "url(#paint476_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1254.94,
    cy: 408.267,
    r: 50,
    transform: "rotate(180 1254.94 408.267)",
    fill: "url(#paint477_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1255.97,
    cy: 405.936,
    r: 50,
    transform: "rotate(180 1255.97 405.936)",
    fill: "url(#paint478_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1257,
    cy: 403.605,
    r: 50,
    transform: "rotate(180 1257 403.605)",
    fill: "url(#paint479_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258.03,
    cy: 401.274,
    r: 50,
    transform: "rotate(180 1258.03 401.274)",
    fill: "url(#paint480_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1259.06,
    cy: 398.944,
    r: 50,
    transform: "rotate(180 1259.06 398.944)",
    fill: "url(#paint481_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1260.09,
    cy: 396.613,
    r: 50,
    transform: "rotate(180 1260.09 396.613)",
    fill: "url(#paint482_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1261.12,
    cy: 394.282,
    r: 50,
    transform: "rotate(180 1261.12 394.282)",
    fill: "url(#paint483_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1262.15,
    cy: 391.952,
    r: 50,
    transform: "rotate(180 1262.15 391.952)",
    fill: "url(#paint484_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1263.18,
    cy: 389.621,
    r: 50,
    transform: "rotate(180 1263.18 389.621)",
    fill: "url(#paint485_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1264.21,
    cy: 387.291,
    r: 50,
    transform: "rotate(180 1264.21 387.291)",
    fill: "url(#paint486_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1265.24,
    cy: 384.96,
    r: 50,
    transform: "rotate(180 1265.24 384.96)",
    fill: "url(#paint487_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1266.28,
    cy: 382.629,
    r: 50,
    transform: "rotate(180 1266.28 382.629)",
    fill: "url(#paint488_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1267.3,
    cy: 380.299,
    r: 50,
    transform: "rotate(180 1267.3 380.299)",
    fill: "url(#paint489_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1268.34,
    cy: 377.968,
    r: 50,
    transform: "rotate(180 1268.34 377.968)",
    fill: "url(#paint490_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1269.37,
    cy: 375.638,
    r: 50,
    transform: "rotate(180 1269.37 375.638)",
    fill: "url(#paint491_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1270.4,
    cy: 373.307,
    r: 50,
    transform: "rotate(180 1270.4 373.307)",
    fill: "url(#paint492_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1271.43,
    cy: 370.976,
    r: 50,
    transform: "rotate(180 1271.43 370.976)",
    fill: "url(#paint493_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1272.46,
    cy: 368.646,
    r: 50,
    transform: "rotate(180 1272.46 368.646)",
    fill: "url(#paint494_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1273.49,
    cy: 366.314,
    r: 50,
    transform: "rotate(180 1273.49 366.314)",
    fill: "url(#paint495_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1274.52,
    cy: 363.984,
    r: 50,
    transform: "rotate(180 1274.52 363.984)",
    fill: "url(#paint496_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1275.55,
    cy: 361.653,
    r: 50,
    transform: "rotate(180 1275.55 361.653)",
    fill: "url(#paint497_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1276.58,
    cy: 359.322,
    r: 50,
    transform: "rotate(180 1276.58 359.322)",
    fill: "url(#paint498_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1277.61,
    cy: 356.992,
    r: 50,
    transform: "rotate(180 1277.61 356.992)",
    fill: "url(#paint499_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1278.64,
    cy: 354.661,
    r: 50,
    transform: "rotate(180 1278.64 354.661)",
    fill: "url(#paint500_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1279.67,
    cy: 352.331,
    r: 50,
    transform: "rotate(180 1279.67 352.331)",
    fill: "url(#paint501_linear_2728_79987)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1280.7,
    cy: 350,
    r: 50,
    transform: "rotate(180 1280.7 350)",
    fill: "url(#paint502_linear_2728_79987)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2728_79987",
    x: 0,
    y: 0,
    width: 1630.7,
    height: 1356.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_2728_79987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2728_79987",
    x1: 302.187,
    y1: 959.028,
    x2: 381.725,
    y2: 967.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2728_79987",
    x1: 303.989,
    y1: 957.227,
    x2: 383.527,
    y2: 965.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2728_79987",
    x1: 305.791,
    y1: 955.425,
    x2: 385.329,
    y2: 964.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2728_79987",
    x1: 307.594,
    y1: 953.623,
    x2: 387.132,
    y2: 962.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2728_79987",
    x1: 309.395,
    y1: 951.82,
    x2: 388.932,
    y2: 960.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2728_79987",
    x1: 311.197,
    y1: 950.019,
    x2: 390.735,
    y2: 958.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2728_79987",
    x1: 312.998,
    y1: 948.217,
    x2: 392.536,
    y2: 956.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2728_79987",
    x1: 314.801,
    y1: 946.415,
    x2: 394.339,
    y2: 955.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2728_79987",
    x1: 316.603,
    y1: 944.613,
    x2: 396.14,
    y2: 953.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2728_79987",
    x1: 318.404,
    y1: 942.812,
    x2: 397.942,
    y2: 951.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2728_79987",
    x1: 320.206,
    y1: 941.01,
    x2: 399.744,
    y2: 949.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2728_79987",
    x1: 322.008,
    y1: 939.208,
    x2: 401.546,
    y2: 947.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2728_79987",
    x1: 323.811,
    y1: 937.406,
    x2: 403.348,
    y2: 946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2728_79987",
    x1: 325.611,
    y1: 935.605,
    x2: 405.149,
    y2: 944.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2728_79987",
    x1: 327.414,
    y1: 933.802,
    x2: 406.952,
    y2: 942.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2728_79987",
    x1: 329.215,
    y1: 932,
    x2: 408.753,
    y2: 940.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2728_79987",
    x1: 331.018,
    y1: 930.198,
    x2: 410.555,
    y2: 938.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2728_79987",
    x1: 332.819,
    y1: 928.397,
    x2: 412.357,
    y2: 936.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2728_79987",
    x1: 334.621,
    y1: 926.595,
    x2: 414.159,
    y2: 935.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2728_79987",
    x1: 336.423,
    y1: 924.793,
    x2: 415.961,
    y2: 933.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2728_79987",
    x1: 338.225,
    y1: 922.991,
    x2: 417.762,
    y2: 931.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2728_79987",
    x1: 340.027,
    y1: 921.19,
    x2: 419.565,
    y2: 929.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2728_79987",
    x1: 341.828,
    y1: 919.388,
    x2: 421.366,
    y2: 927.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2728_79987",
    x1: 343.631,
    y1: 917.586,
    x2: 423.169,
    y2: 926.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2728_79987",
    x1: 345.432,
    y1: 915.783,
    x2: 424.969,
    y2: 924.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2728_79987",
    x1: 347.234,
    y1: 913.982,
    x2: 426.772,
    y2: 922.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2728_79987",
    x1: 349.036,
    y1: 912.18,
    x2: 428.574,
    y2: 920.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2728_79987",
    x1: 350.838,
    y1: 910.378,
    x2: 430.376,
    y2: 918.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2728_79987",
    x1: 352.64,
    y1: 908.576,
    x2: 432.177,
    y2: 917.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2728_79987",
    x1: 354.441,
    y1: 906.775,
    x2: 433.979,
    y2: 915.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2728_79987",
    x1: 356.243,
    y1: 904.973,
    x2: 435.781,
    y2: 913.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2728_79987",
    x1: 358.045,
    y1: 903.171,
    x2: 437.583,
    y2: 911.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2728_79987",
    x1: 359.848,
    y1: 901.369,
    x2: 439.385,
    y2: 909.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2728_79987",
    x1: 361.648,
    y1: 899.567,
    x2: 441.186,
    y2: 908.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2728_79987",
    x1: 363.451,
    y1: 897.765,
    x2: 442.989,
    y2: 906.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2728_79987",
    x1: 365.252,
    y1: 895.963,
    x2: 444.79,
    y2: 904.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2728_79987",
    x1: 367.055,
    y1: 894.161,
    x2: 446.592,
    y2: 902.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2728_79987",
    x1: 368.856,
    y1: 892.36,
    x2: 448.394,
    y2: 900.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2728_79987",
    x1: 370.658,
    y1: 890.558,
    x2: 450.196,
    y2: 899.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2728_79987",
    x1: 372.46,
    y1: 888.756,
    x2: 451.998,
    y2: 897.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2728_79987",
    x1: 374.262,
    y1: 886.954,
    x2: 453.799,
    y2: 895.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2728_79987",
    x1: 376.064,
    y1: 885.152,
    x2: 455.602,
    y2: 893.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2728_79987",
    x1: 377.865,
    y1: 883.351,
    x2: 457.403,
    y2: 891.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2728_79987",
    x1: 379.668,
    y1: 881.548,
    x2: 459.206,
    y2: 890.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2728_79987",
    x1: 381.469,
    y1: 879.746,
    x2: 461.007,
    y2: 888.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2728_79987",
    x1: 383.271,
    y1: 877.944,
    x2: 462.809,
    y2: 886.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2728_79987",
    x1: 385.073,
    y1: 876.143,
    x2: 464.611,
    y2: 884.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2728_79987",
    x1: 386.875,
    y1: 874.341,
    x2: 466.413,
    y2: 882.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2728_79987",
    x1: 388.677,
    y1: 872.539,
    x2: 468.215,
    y2: 881.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2728_79987",
    x1: 390.479,
    y1: 870.737,
    x2: 470.016,
    y2: 879.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2728_79987",
    x1: 392.281,
    y1: 868.936,
    x2: 471.819,
    y2: 877.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2728_79987",
    x1: 394.082,
    y1: 867.134,
    x2: 473.62,
    y2: 875.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2728_79987",
    x1: 395.885,
    y1: 865.332,
    x2: 475.423,
    y2: 873.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2728_79987",
    x1: 397.686,
    y1: 863.529,
    x2: 477.223,
    y2: 872.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2728_79987",
    x1: 399.488,
    y1: 861.728,
    x2: 479.026,
    y2: 870.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2728_79987",
    x1: 401.29,
    y1: 859.926,
    x2: 480.828,
    y2: 868.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2728_79987",
    x1: 403.092,
    y1: 858.124,
    x2: 482.63,
    y2: 866.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2728_79987",
    x1: 404.894,
    y1: 856.322,
    x2: 484.431,
    y2: 864.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2728_79987",
    x1: 406.695,
    y1: 854.521,
    x2: 486.233,
    y2: 863.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2728_79987",
    x1: 408.497,
    y1: 852.719,
    x2: 488.035,
    y2: 861.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2728_79987",
    x1: 410.299,
    y1: 850.917,
    x2: 489.837,
    y2: 859.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2728_79987",
    x1: 412.102,
    y1: 849.115,
    x2: 491.639,
    y2: 857.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2728_79987",
    x1: 413.902,
    y1: 847.314,
    x2: 493.44,
    y2: 855.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2728_79987",
    x1: 415.705,
    y1: 845.511,
    x2: 495.243,
    y2: 854.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2728_79987",
    x1: 417.506,
    y1: 843.709,
    x2: 497.044,
    y2: 852.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2728_79987",
    x1: 419.309,
    y1: 841.907,
    x2: 498.846,
    y2: 850.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2728_79987",
    x1: 421.11,
    y1: 840.106,
    x2: 500.648,
    y2: 848.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2728_79987",
    x1: 422.912,
    y1: 838.304,
    x2: 502.45,
    y2: 846.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2728_79987",
    x1: 424.714,
    y1: 836.502,
    x2: 504.252,
    y2: 845.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2728_79987",
    x1: 426.516,
    y1: 834.7,
    x2: 506.053,
    y2: 843.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2728_79987",
    x1: 428.318,
    y1: 832.899,
    x2: 507.856,
    y2: 841.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2728_79987",
    x1: 430.119,
    y1: 831.097,
    x2: 509.657,
    y2: 839.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2728_79987",
    x1: 431.922,
    y1: 829.294,
    x2: 511.46,
    y2: 837.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2728_79987",
    x1: 433.723,
    y1: 827.492,
    x2: 513.26,
    y2: 836.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2728_79987",
    x1: 435.525,
    y1: 825.691,
    x2: 515.063,
    y2: 834.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2728_79987",
    x1: 437.327,
    y1: 823.889,
    x2: 516.865,
    y2: 832.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2728_79987",
    x1: 439.129,
    y1: 822.087,
    x2: 518.667,
    y2: 830.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2728_79987",
    x1: 440.931,
    y1: 820.285,
    x2: 520.468,
    y2: 828.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2728_79987",
    x1: 442.732,
    y1: 818.484,
    x2: 522.27,
    y2: 827.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2728_79987",
    x1: 444.534,
    y1: 816.682,
    x2: 524.072,
    y2: 825.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2728_79987",
    x1: 446.336,
    y1: 814.88,
    x2: 525.874,
    y2: 823.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2728_79987",
    x1: 448.139,
    y1: 813.078,
    x2: 527.676,
    y2: 821.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2728_79987",
    x1: 449.939,
    y1: 811.276,
    x2: 529.477,
    y2: 819.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2728_79987",
    x1: 451.742,
    y1: 809.474,
    x2: 531.28,
    y2: 818.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2728_79987",
    x1: 453.544,
    y1: 807.672,
    x2: 533.082,
    y2: 816.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2728_79987",
    x1: 455.346,
    y1: 805.87,
    x2: 534.883,
    y2: 814.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2728_79987",
    x1: 457.147,
    y1: 804.069,
    x2: 536.685,
    y2: 812.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2728_79987",
    x1: 458.949,
    y1: 802.267,
    x2: 538.487,
    y2: 810.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2728_79987",
    x1: 460.751,
    y1: 800.465,
    x2: 540.289,
    y2: 809.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2728_79987",
    x1: 462.553,
    y1: 798.663,
    x2: 542.091,
    y2: 807.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2728_79987",
    x1: 464.355,
    y1: 796.861,
    x2: 543.893,
    y2: 805.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2728_79987",
    x1: 466.156,
    y1: 795.06,
    x2: 545.694,
    y2: 803.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2728_79987",
    x1: 467.959,
    y1: 793.257,
    x2: 547.497,
    y2: 801.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2728_79987",
    x1: 469.76,
    y1: 791.455,
    x2: 549.298,
    y2: 800.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2728_79987",
    x1: 471.562,
    y1: 789.653,
    x2: 551.1,
    y2: 798.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2728_79987",
    x1: 473.364,
    y1: 787.852,
    x2: 552.902,
    y2: 796.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2728_79987",
    x1: 475.166,
    y1: 786.05,
    x2: 554.704,
    y2: 794.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2728_79987",
    x1: 476.968,
    y1: 784.248,
    x2: 556.506,
    y2: 792.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2728_79987",
    x1: 478.77,
    y1: 782.446,
    x2: 558.307,
    y2: 791.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2728_79987",
    x1: 480.572,
    y1: 780.645,
    x2: 560.11,
    y2: 789.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2728_79987",
    x1: 482.373,
    y1: 778.843,
    x2: 561.911,
    y2: 787.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2728_79987",
    x1: 484.176,
    y1: 777.04,
    x2: 563.714,
    y2: 785.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2728_79987",
    x1: 485.977,
    y1: 775.238,
    x2: 565.514,
    y2: 783.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2728_79987",
    x1: 487.779,
    y1: 773.437,
    x2: 567.317,
    y2: 782.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2728_79987",
    x1: 489.581,
    y1: 771.635,
    x2: 569.119,
    y2: 780.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2728_79987",
    x1: 491.383,
    y1: 769.833,
    x2: 570.921,
    y2: 778.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2728_79987",
    x1: 493.185,
    y1: 768.031,
    x2: 572.722,
    y2: 776.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2728_79987",
    x1: 494.986,
    y1: 766.23,
    x2: 574.524,
    y2: 774.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2728_79987",
    x1: 496.788,
    y1: 764.428,
    x2: 576.326,
    y2: 773.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2728_79987",
    x1: 498.59,
    y1: 762.626,
    x2: 578.128,
    y2: 771.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2728_79987",
    x1: 500.393,
    y1: 760.824,
    x2: 579.93,
    y2: 769.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2728_79987",
    x1: 502.193,
    y1: 759.022,
    x2: 581.731,
    y2: 767.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2728_79987",
    x1: 503.996,
    y1: 757.22,
    x2: 583.534,
    y2: 765.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2728_79987",
    x1: 505.798,
    y1: 755.418,
    x2: 585.336,
    y2: 764.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2728_79987",
    x1: 507.6,
    y1: 753.616,
    x2: 587.137,
    y2: 762.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2728_79987",
    x1: 509.401,
    y1: 751.815,
    x2: 588.939,
    y2: 760.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2728_79987",
    x1: 511.203,
    y1: 750.013,
    x2: 590.741,
    y2: 758.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2728_79987",
    x1: 513.005,
    y1: 748.211,
    x2: 592.543,
    y2: 756.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2728_79987",
    x1: 514.807,
    y1: 746.409,
    x2: 594.344,
    y2: 755.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2728_79987",
    x1: 516.609,
    y1: 744.608,
    x2: 596.147,
    y2: 753.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2728_79987",
    x1: 518.41,
    y1: 742.806,
    x2: 597.948,
    y2: 751.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2728_79987",
    x1: 520.213,
    y1: 741.003,
    x2: 599.751,
    y2: 749.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2728_79987",
    x1: 522.014,
    y1: 739.201,
    x2: 601.551,
    y2: 747.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2728_79987",
    x1: 523.816,
    y1: 737.4,
    x2: 603.354,
    y2: 745.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2728_79987",
    x1: 525.618,
    y1: 735.598,
    x2: 605.156,
    y2: 744.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2728_79987",
    x1: 527.42,
    y1: 733.796,
    x2: 606.958,
    y2: 742.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2728_79987",
    x1: 529.222,
    y1: 731.994,
    x2: 608.759,
    y2: 740.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2728_79987",
    x1: 531.023,
    y1: 730.193,
    x2: 610.561,
    y2: 738.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2728_79987",
    x1: 532.826,
    y1: 728.391,
    x2: 612.364,
    y2: 736.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2728_79987",
    x1: 534.627,
    y1: 726.589,
    x2: 614.165,
    y2: 735.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2728_79987",
    x1: 536.43,
    y1: 724.786,
    x2: 615.967,
    y2: 733.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2728_79987",
    x1: 538.23,
    y1: 722.985,
    x2: 617.768,
    y2: 731.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2728_79987",
    x1: 540.033,
    y1: 721.183,
    x2: 619.571,
    y2: 729.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2728_79987",
    x1: 541.835,
    y1: 719.381,
    x2: 621.373,
    y2: 727.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2728_79987",
    x1: 543.637,
    y1: 717.579,
    x2: 623.174,
    y2: 726.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2728_79987",
    x1: 545.438,
    y1: 715.777,
    x2: 624.976,
    y2: 724.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2728_79987",
    x1: 547.24,
    y1: 713.976,
    x2: 626.778,
    y2: 722.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2728_79987",
    x1: 549.042,
    y1: 712.174,
    x2: 628.58,
    y2: 720.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2728_79987",
    x1: 550.844,
    y1: 710.372,
    x2: 630.382,
    y2: 718.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2728_79987",
    x1: 552.646,
    y1: 708.57,
    x2: 632.184,
    y2: 717.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2728_79987",
    x1: 554.447,
    y1: 706.768,
    x2: 633.985,
    y2: 715.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2728_79987",
    x1: 556.25,
    y1: 704.966,
    x2: 635.788,
    y2: 713.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2728_79987",
    x1: 558.051,
    y1: 703.164,
    x2: 637.589,
    y2: 711.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2728_79987",
    x1: 559.854,
    y1: 701.362,
    x2: 639.391,
    y2: 709.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2728_79987",
    x1: 561.655,
    y1: 699.561,
    x2: 641.193,
    y2: 708.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2728_79987",
    x1: 563.457,
    y1: 697.759,
    x2: 642.995,
    y2: 706.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2728_79987",
    x1: 565.259,
    y1: 695.957,
    x2: 644.797,
    y2: 704.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2728_79987",
    x1: 567.061,
    y1: 694.155,
    x2: 646.598,
    y2: 702.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2728_79987",
    x1: 568.863,
    y1: 692.354,
    x2: 648.401,
    y2: 700.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2728_79987",
    x1: 570.664,
    y1: 690.552,
    x2: 650.202,
    y2: 699.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2728_79987",
    x1: 572.467,
    y1: 688.749,
    x2: 652.005,
    y2: 697.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2728_79987",
    x1: 574.268,
    y1: 686.947,
    x2: 653.805,
    y2: 695.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2728_79987",
    x1: 576.07,
    y1: 685.146,
    x2: 655.608,
    y2: 693.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2728_79987",
    x1: 577.872,
    y1: 683.344,
    x2: 657.41,
    y2: 691.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2728_79987",
    x1: 579.674,
    y1: 681.542,
    x2: 659.212,
    y2: 690.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2728_79987",
    x1: 581.476,
    y1: 679.74,
    x2: 661.013,
    y2: 688.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2728_79987",
    x1: 583.277,
    y1: 677.939,
    x2: 662.815,
    y2: 686.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2728_79987",
    x1: 585.08,
    y1: 676.137,
    x2: 664.618,
    y2: 684.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2728_79987",
    x1: 586.881,
    y1: 674.335,
    x2: 666.419,
    y2: 682.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2728_79987",
    x1: 588.684,
    y1: 672.533,
    x2: 668.221,
    y2: 681.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2728_79987",
    x1: 590.484,
    y1: 670.731,
    x2: 670.022,
    y2: 679.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2728_79987",
    x1: 592.287,
    y1: 668.929,
    x2: 671.825,
    y2: 677.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2728_79987",
    x1: 594.089,
    y1: 667.127,
    x2: 673.627,
    y2: 675.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2728_79987",
    x1: 595.891,
    y1: 665.325,
    x2: 675.428,
    y2: 673.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2728_79987",
    x1: 597.692,
    y1: 663.524,
    x2: 677.23,
    y2: 672.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2728_79987",
    x1: 599.494,
    y1: 661.722,
    x2: 679.032,
    y2: 670.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2728_79987",
    x1: 601.296,
    y1: 659.92,
    x2: 680.834,
    y2: 668.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2728_79987",
    x1: 603.098,
    y1: 658.118,
    x2: 682.635,
    y2: 666.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2728_79987",
    x1: 604.9,
    y1: 656.317,
    x2: 684.438,
    y2: 664.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2728_79987",
    x1: 606.701,
    y1: 654.514,
    x2: 686.239,
    y2: 663.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2728_79987",
    x1: 608.504,
    y1: 652.712,
    x2: 688.042,
    y2: 661.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2728_79987",
    x1: 610.305,
    y1: 650.91,
    x2: 689.842,
    y2: 659.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2728_79987",
    x1: 612.107,
    y1: 649.109,
    x2: 691.645,
    y2: 657.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2728_79987",
    x1: 613.909,
    y1: 647.307,
    x2: 693.447,
    y2: 655.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2728_79987",
    x1: 615.711,
    y1: 645.505,
    x2: 695.249,
    y2: 654.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2728_79987",
    x1: 617.513,
    y1: 643.703,
    x2: 697.05,
    y2: 652.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2728_79987",
    x1: 619.314,
    y1: 641.902,
    x2: 698.852,
    y2: 650.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2728_79987",
    x1: 621.117,
    y1: 640.1,
    x2: 700.655,
    y2: 648.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2728_79987",
    x1: 622.918,
    y1: 638.298,
    x2: 702.456,
    y2: 646.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2728_79987",
    x1: 624.721,
    y1: 636.495,
    x2: 704.258,
    y2: 645.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2728_79987",
    x1: 626.521,
    y1: 634.694,
    x2: 706.059,
    y2: 643.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2728_79987",
    x1: 628.324,
    y1: 632.892,
    x2: 707.862,
    y2: 641.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2728_79987",
    x1: 630.126,
    y1: 631.09,
    x2: 709.664,
    y2: 639.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2728_79987",
    x1: 631.928,
    y1: 629.288,
    x2: 711.466,
    y2: 637.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2728_79987",
    x1: 633.729,
    y1: 627.486,
    x2: 713.267,
    y2: 636.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2728_79987",
    x1: 635.799,
    y1: 626.33,
    x2: 715.337,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2728_79987",
    x1: 638.348,
    y1: 626.33,
    x2: 717.885,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2728_79987",
    x1: 640.896,
    y1: 626.33,
    x2: 720.433,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2728_79987",
    x1: 643.443,
    y1: 626.33,
    x2: 722.981,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2728_79987",
    x1: 645.992,
    y1: 626.33,
    x2: 725.53,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2728_79987",
    x1: 648.54,
    y1: 626.33,
    x2: 728.078,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2728_79987",
    x1: 651.088,
    y1: 626.33,
    x2: 730.626,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2728_79987",
    x1: 653.637,
    y1: 626.33,
    x2: 733.174,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2728_79987",
    x1: 656.185,
    y1: 626.33,
    x2: 735.722,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2728_79987",
    x1: 658.732,
    y1: 626.33,
    x2: 738.27,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2728_79987",
    x1: 661.281,
    y1: 626.33,
    x2: 740.819,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2728_79987",
    x1: 663.829,
    y1: 626.33,
    x2: 743.367,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2728_79987",
    x1: 666.377,
    y1: 626.33,
    x2: 745.915,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2728_79987",
    x1: 668.926,
    y1: 626.33,
    x2: 748.464,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2728_79987",
    x1: 671.474,
    y1: 626.33,
    x2: 751.011,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2728_79987",
    x1: 674.021,
    y1: 626.33,
    x2: 753.559,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2728_79987",
    x1: 676.57,
    y1: 626.33,
    x2: 756.108,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2728_79987",
    x1: 679.119,
    y1: 626.33,
    x2: 758.657,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2728_79987",
    x1: 681.666,
    y1: 626.33,
    x2: 761.204,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_2728_79987",
    x1: 684.215,
    y1: 626.33,
    x2: 763.753,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2728_79987",
    x1: 686.764,
    y1: 626.33,
    x2: 766.301,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2728_79987",
    x1: 689.312,
    y1: 626.33,
    x2: 768.849,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2728_79987",
    x1: 691.859,
    y1: 626.33,
    x2: 771.397,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2728_79987",
    x1: 694.408,
    y1: 626.33,
    x2: 773.946,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2728_79987",
    x1: 696.956,
    y1: 626.33,
    x2: 776.494,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2728_79987",
    x1: 699.504,
    y1: 626.33,
    x2: 779.042,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2728_79987",
    x1: 702.053,
    y1: 626.33,
    x2: 781.591,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2728_79987",
    x1: 704.601,
    y1: 626.33,
    x2: 784.138,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2728_79987",
    x1: 707.148,
    y1: 626.33,
    x2: 786.686,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_2728_79987",
    x1: 709.697,
    y1: 626.33,
    x2: 789.235,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_2728_79987",
    x1: 712.245,
    y1: 626.33,
    x2: 791.783,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_2728_79987",
    x1: 714.793,
    y1: 626.33,
    x2: 794.331,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_2728_79987",
    x1: 717.342,
    y1: 626.33,
    x2: 796.88,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_2728_79987",
    x1: 719.89,
    y1: 626.33,
    x2: 799.427,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_2728_79987",
    x1: 722.437,
    y1: 626.33,
    x2: 801.975,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_2728_79987",
    x1: 724.986,
    y1: 626.33,
    x2: 804.524,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_2728_79987",
    x1: 727.535,
    y1: 626.33,
    x2: 807.073,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_2728_79987",
    x1: 730.082,
    y1: 626.33,
    x2: 809.62,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_2728_79987",
    x1: 732.631,
    y1: 626.33,
    x2: 812.169,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_2728_79987",
    x1: 735.18,
    y1: 626.33,
    x2: 814.717,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_2728_79987",
    x1: 737.728,
    y1: 626.33,
    x2: 817.265,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_2728_79987",
    x1: 740.275,
    y1: 626.33,
    x2: 819.813,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_2728_79987",
    x1: 742.824,
    y1: 626.33,
    x2: 822.362,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_2728_79987",
    x1: 745.372,
    y1: 626.33,
    x2: 824.91,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_2728_79987",
    x1: 747.92,
    y1: 626.33,
    x2: 827.458,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_2728_79987",
    x1: 750.469,
    y1: 626.33,
    x2: 830.007,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_2728_79987",
    x1: 753.017,
    y1: 626.33,
    x2: 832.554,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_2728_79987",
    x1: 755.564,
    y1: 626.33,
    x2: 835.102,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_2728_79987",
    x1: 758.113,
    y1: 626.33,
    x2: 837.651,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_2728_79987",
    x1: 760.661,
    y1: 626.33,
    x2: 840.199,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_2728_79987",
    x1: 763.209,
    y1: 626.33,
    x2: 842.747,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_2728_79987",
    x1: 765.758,
    y1: 626.33,
    x2: 845.296,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_2728_79987",
    x1: 768.307,
    y1: 626.33,
    x2: 847.844,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_2728_79987",
    x1: 770.854,
    y1: 626.33,
    x2: 850.391,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_2728_79987",
    x1: 773.402,
    y1: 626.33,
    x2: 852.94,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_2728_79987",
    x1: 775.951,
    y1: 626.33,
    x2: 855.489,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_2728_79987",
    x1: 778.498,
    y1: 626.33,
    x2: 858.036,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_2728_79987",
    x1: 781.047,
    y1: 626.33,
    x2: 860.585,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_2728_79987",
    x1: 783.596,
    y1: 626.33,
    x2: 863.133,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_2728_79987",
    x1: 786.144,
    y1: 626.33,
    x2: 865.681,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_2728_79987",
    x1: 788.691,
    y1: 626.33,
    x2: 868.229,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_2728_79987",
    x1: 791.24,
    y1: 626.33,
    x2: 870.778,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_2728_79987",
    x1: 793.788,
    y1: 626.33,
    x2: 873.326,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_2728_79987",
    x1: 796.336,
    y1: 626.33,
    x2: 875.874,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_2728_79987",
    x1: 798.885,
    y1: 626.33,
    x2: 878.423,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_2728_79987",
    x1: 801.433,
    y1: 626.33,
    x2: 880.97,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_2728_79987",
    x1: 803.98,
    y1: 626.33,
    x2: 883.518,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_2728_79987",
    x1: 806.529,
    y1: 626.33,
    x2: 886.067,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_2728_79987",
    x1: 809.077,
    y1: 626.33,
    x2: 888.615,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_2728_79987",
    x1: 811.625,
    y1: 626.33,
    x2: 891.163,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_2728_79987",
    x1: 814.174,
    y1: 626.33,
    x2: 893.712,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_2728_79987",
    x1: 816.723,
    y1: 626.33,
    x2: 896.26,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_2728_79987",
    x1: 819.27,
    y1: 626.33,
    x2: 898.807,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_2728_79987",
    x1: 821.818,
    y1: 626.33,
    x2: 901.356,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_2728_79987",
    x1: 824.367,
    y1: 626.33,
    x2: 903.905,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_2728_79987",
    x1: 826.915,
    y1: 626.33,
    x2: 906.453,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_2728_79987",
    x1: 829.463,
    y1: 626.33,
    x2: 909.001,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_2728_79987",
    x1: 832.012,
    y1: 626.33,
    x2: 911.549,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_2728_79987",
    x1: 834.56,
    y1: 626.33,
    x2: 914.097,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_2728_79987",
    x1: 837.107,
    y1: 626.33,
    x2: 916.645,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_2728_79987",
    x1: 839.656,
    y1: 626.33,
    x2: 919.194,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_2728_79987",
    x1: 842.204,
    y1: 626.33,
    x2: 921.742,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_2728_79987",
    x1: 844.752,
    y1: 626.33,
    x2: 924.29,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_2728_79987",
    x1: 847.301,
    y1: 626.33,
    x2: 926.839,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_2728_79987",
    x1: 849.849,
    y1: 626.33,
    x2: 929.386,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_2728_79987",
    x1: 852.396,
    y1: 626.33,
    x2: 931.934,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_2728_79987",
    x1: 854.945,
    y1: 626.33,
    x2: 934.483,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_2728_79987",
    x1: 857.493,
    y1: 626.33,
    x2: 937.031,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_2728_79987",
    x1: 860.041,
    y1: 626.33,
    x2: 939.579,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_2728_79987",
    x1: 862.59,
    y1: 626.33,
    x2: 942.128,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_2728_79987",
    x1: 865.139,
    y1: 626.33,
    x2: 944.676,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_2728_79987",
    x1: 867.686,
    y1: 626.33,
    x2: 947.223,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_2728_79987",
    x1: 870.234,
    y1: 626.33,
    x2: 949.772,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_2728_79987",
    x1: 872.783,
    y1: 626.33,
    x2: 952.321,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_2728_79987",
    x1: 875.331,
    y1: 626.33,
    x2: 954.869,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_2728_79987",
    x1: 877.879,
    y1: 626.33,
    x2: 957.417,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_2728_79987",
    x1: 880.428,
    y1: 626.33,
    x2: 959.966,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_2728_79987",
    x1: 882.976,
    y1: 626.33,
    x2: 962.513,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_2728_79987",
    x1: 885.523,
    y1: 626.33,
    x2: 965.061,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_2728_79987",
    x1: 888.072,
    y1: 626.33,
    x2: 967.61,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_2728_79987",
    x1: 890.62,
    y1: 626.33,
    x2: 970.158,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_2728_79987",
    x1: 893.168,
    y1: 626.33,
    x2: 972.706,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_2728_79987",
    x1: 895.717,
    y1: 626.33,
    x2: 975.255,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_2728_79987",
    x1: 898.265,
    y1: 626.33,
    x2: 977.802,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_2728_79987",
    x1: 900.812,
    y1: 626.33,
    x2: 980.35,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_2728_79987",
    x1: 903.361,
    y1: 626.33,
    x2: 982.899,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_2728_79987",
    x1: 905.909,
    y1: 626.33,
    x2: 985.447,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_2728_79987",
    x1: 908.457,
    y1: 626.33,
    x2: 987.995,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_2728_79987",
    x1: 911.006,
    y1: 626.33,
    x2: 990.544,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_2728_79987",
    x1: 913.555,
    y1: 626.33,
    x2: 993.092,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_2728_79987",
    x1: 916.102,
    y1: 626.33,
    x2: 995.639,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_2728_79987",
    x1: 918.65,
    y1: 626.33,
    x2: 998.188,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_2728_79987",
    x1: 921.199,
    y1: 626.33,
    x2: 1000.74,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_2728_79987",
    x1: 923.747,
    y1: 626.33,
    x2: 1003.28,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_2728_79987",
    x1: 926.295,
    y1: 626.33,
    x2: 1005.83,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_2728_79987",
    x1: 928.844,
    y1: 626.33,
    x2: 1008.38,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_2728_79987",
    x1: 931.392,
    y1: 626.33,
    x2: 1010.93,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_2728_79987",
    x1: 933.939,
    y1: 626.33,
    x2: 1013.48,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_2728_79987",
    x1: 936.488,
    y1: 626.33,
    x2: 1016.03,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_2728_79987",
    x1: 939.036,
    y1: 626.33,
    x2: 1018.57,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_2728_79987",
    x1: 941.584,
    y1: 626.33,
    x2: 1021.12,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_2728_79987",
    x1: 944.133,
    y1: 626.33,
    x2: 1023.67,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_2728_79987",
    x1: 946.681,
    y1: 626.33,
    x2: 1026.22,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_2728_79987",
    x1: 949.229,
    y1: 626.33,
    x2: 1028.77,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_2728_79987",
    x1: 951.777,
    y1: 626.33,
    x2: 1031.32,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_2728_79987",
    x1: 954.326,
    y1: 626.33,
    x2: 1033.86,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_2728_79987",
    x1: 956.873,
    y1: 626.33,
    x2: 1036.41,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_2728_79987",
    x1: 959.422,
    y1: 626.33,
    x2: 1038.96,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_2728_79987",
    x1: 961.971,
    y1: 626.33,
    x2: 1041.51,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_2728_79987",
    x1: 964.518,
    y1: 626.33,
    x2: 1044.06,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_2728_79987",
    x1: 967.066,
    y1: 626.33,
    x2: 1046.6,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_2728_79987",
    x1: 969.615,
    y1: 626.33,
    x2: 1049.15,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_2728_79987",
    x1: 972.163,
    y1: 626.33,
    x2: 1051.7,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_2728_79987",
    x1: 974.711,
    y1: 626.33,
    x2: 1054.25,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_2728_79987",
    x1: 977.26,
    y1: 626.33,
    x2: 1056.8,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_2728_79987",
    x1: 979.808,
    y1: 626.33,
    x2: 1059.35,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_2728_79987",
    x1: 982.355,
    y1: 626.33,
    x2: 1061.89,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_2728_79987",
    x1: 984.904,
    y1: 626.33,
    x2: 1064.44,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_2728_79987",
    x1: 987.452,
    y1: 626.33,
    x2: 1066.99,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_2728_79987",
    x1: 990,
    y1: 626.33,
    x2: 1069.54,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_2728_79987",
    x1: 992.549,
    y1: 626.33,
    x2: 1072.09,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_2728_79987",
    x1: 995.097,
    y1: 626.33,
    x2: 1074.63,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_2728_79987",
    x1: 997.645,
    y1: 626.33,
    x2: 1077.18,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_2728_79987",
    x1: 1000.19,
    y1: 626.33,
    x2: 1079.73,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_2728_79987",
    x1: 1002.74,
    y1: 626.33,
    x2: 1082.28,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_2728_79987",
    x1: 1005.29,
    y1: 626.33,
    x2: 1084.83,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_2728_79987",
    x1: 1007.84,
    y1: 626.33,
    x2: 1087.38,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_2728_79987",
    x1: 1010.39,
    y1: 626.33,
    x2: 1089.92,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_2728_79987",
    x1: 1012.93,
    y1: 626.33,
    x2: 1092.47,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_2728_79987",
    x1: 1015.48,
    y1: 626.33,
    x2: 1095.02,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_2728_79987",
    x1: 1018.03,
    y1: 626.33,
    x2: 1097.57,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_2728_79987",
    x1: 1020.58,
    y1: 626.33,
    x2: 1100.12,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_2728_79987",
    x1: 1023.13,
    y1: 626.33,
    x2: 1102.66,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_2728_79987",
    x1: 1025.68,
    y1: 626.33,
    x2: 1105.21,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_2728_79987",
    x1: 1028.22,
    y1: 626.33,
    x2: 1107.76,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_2728_79987",
    x1: 1030.77,
    y1: 626.33,
    x2: 1110.31,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_2728_79987",
    x1: 1033.32,
    y1: 626.33,
    x2: 1112.86,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_2728_79987",
    x1: 1035.87,
    y1: 626.33,
    x2: 1115.41,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_2728_79987",
    x1: 1038.42,
    y1: 626.33,
    x2: 1117.95,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_2728_79987",
    x1: 1040.96,
    y1: 626.33,
    x2: 1120.5,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_2728_79987",
    x1: 1043.51,
    y1: 626.33,
    x2: 1123.05,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_2728_79987",
    x1: 1046.06,
    y1: 626.33,
    x2: 1125.6,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_2728_79987",
    x1: 1048.61,
    y1: 626.33,
    x2: 1128.15,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_2728_79987",
    x1: 1051.16,
    y1: 626.33,
    x2: 1130.7,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_2728_79987",
    x1: 1053.71,
    y1: 626.33,
    x2: 1133.24,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_2728_79987",
    x1: 1056.25,
    y1: 626.33,
    x2: 1135.79,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_2728_79987",
    x1: 1058.8,
    y1: 626.33,
    x2: 1138.34,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_2728_79987",
    x1: 1061.35,
    y1: 626.33,
    x2: 1140.89,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_2728_79987",
    x1: 1063.9,
    y1: 626.33,
    x2: 1143.44,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_2728_79987",
    x1: 1066.45,
    y1: 626.33,
    x2: 1145.99,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_2728_79987",
    x1: 1069,
    y1: 626.33,
    x2: 1148.53,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_2728_79987",
    x1: 1071.54,
    y1: 626.33,
    x2: 1151.08,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_2728_79987",
    x1: 1074.09,
    y1: 626.33,
    x2: 1153.63,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_2728_79987",
    x1: 1076.64,
    y1: 626.33,
    x2: 1156.18,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_2728_79987",
    x1: 1079.19,
    y1: 626.33,
    x2: 1158.73,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_2728_79987",
    x1: 1081.74,
    y1: 626.33,
    x2: 1161.27,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_2728_79987",
    x1: 1084.28,
    y1: 626.33,
    x2: 1163.82,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_2728_79987",
    x1: 1086.83,
    y1: 626.33,
    x2: 1166.37,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_2728_79987",
    x1: 1089.38,
    y1: 626.33,
    x2: 1168.92,
    y2: 634.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_2728_79987",
    x1: 1090.71,
    y1: 624.461,
    x2: 1170.25,
    y2: 633.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_2728_79987",
    x1: 1091.74,
    y1: 622.131,
    x2: 1171.28,
    y2: 630.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_2728_79987",
    x1: 1092.77,
    y1: 619.8,
    x2: 1172.31,
    y2: 628.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_2728_79987",
    x1: 1093.8,
    y1: 617.47,
    x2: 1173.34,
    y2: 626.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_2728_79987",
    x1: 1094.83,
    y1: 615.139,
    x2: 1174.37,
    y2: 623.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_2728_79987",
    x1: 1095.86,
    y1: 612.808,
    x2: 1175.4,
    y2: 621.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_2728_79987",
    x1: 1096.89,
    y1: 610.478,
    x2: 1176.43,
    y2: 619.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_2728_79987",
    x1: 1097.92,
    y1: 608.147,
    x2: 1177.46,
    y2: 616.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_2728_79987",
    x1: 1098.95,
    y1: 605.817,
    x2: 1178.49,
    y2: 614.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_2728_79987",
    x1: 1099.98,
    y1: 603.485,
    x2: 1179.52,
    y2: 612.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_2728_79987",
    x1: 1101.01,
    y1: 601.154,
    x2: 1180.55,
    y2: 609.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_2728_79987",
    x1: 1102.04,
    y1: 598.824,
    x2: 1181.58,
    y2: 607.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_2728_79987",
    x1: 1103.07,
    y1: 596.493,
    x2: 1182.61,
    y2: 605.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_2728_79987",
    x1: 1104.11,
    y1: 594.163,
    x2: 1183.64,
    y2: 602.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_2728_79987",
    x1: 1105.13,
    y1: 591.832,
    x2: 1184.67,
    y2: 600.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_2728_79987",
    x1: 1106.17,
    y1: 589.501,
    x2: 1185.7,
    y2: 598.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_2728_79987",
    x1: 1107.2,
    y1: 587.171,
    x2: 1186.73,
    y2: 595.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_2728_79987",
    x1: 1108.23,
    y1: 584.84,
    x2: 1187.76,
    y2: 593.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_2728_79987",
    x1: 1109.26,
    y1: 582.51,
    x2: 1188.79,
    y2: 591.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_2728_79987",
    x1: 1110.29,
    y1: 580.179,
    x2: 1189.82,
    y2: 588.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_2728_79987",
    x1: 1111.32,
    y1: 577.848,
    x2: 1190.85,
    y2: 586.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_2728_79987",
    x1: 1112.35,
    y1: 575.518,
    x2: 1191.89,
    y2: 584.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_2728_79987",
    x1: 1113.38,
    y1: 573.187,
    x2: 1192.91,
    y2: 581.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_2728_79987",
    x1: 1114.41,
    y1: 570.857,
    x2: 1193.95,
    y2: 579.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_2728_79987",
    x1: 1115.44,
    y1: 568.526,
    x2: 1194.98,
    y2: 577.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_2728_79987",
    x1: 1116.47,
    y1: 566.194,
    x2: 1196.01,
    y2: 574.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_2728_79987",
    x1: 1117.5,
    y1: 563.864,
    x2: 1197.04,
    y2: 572.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_2728_79987",
    x1: 1118.53,
    y1: 561.533,
    x2: 1198.07,
    y2: 570.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_2728_79987",
    x1: 1119.56,
    y1: 559.203,
    x2: 1199.1,
    y2: 567.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_2728_79987",
    x1: 1120.59,
    y1: 556.872,
    x2: 1200.13,
    y2: 565.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_2728_79987",
    x1: 1121.62,
    y1: 554.541,
    x2: 1201.16,
    y2: 563.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_2728_79987",
    x1: 1122.65,
    y1: 552.211,
    x2: 1202.19,
    y2: 560.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_2728_79987",
    x1: 1123.68,
    y1: 549.88,
    x2: 1203.22,
    y2: 558.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_2728_79987",
    x1: 1124.71,
    y1: 547.55,
    x2: 1204.25,
    y2: 556.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_2728_79987",
    x1: 1125.74,
    y1: 545.219,
    x2: 1205.28,
    y2: 553.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_2728_79987",
    x1: 1126.77,
    y1: 542.888,
    x2: 1206.31,
    y2: 551.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_2728_79987",
    x1: 1127.8,
    y1: 540.558,
    x2: 1207.34,
    y2: 549.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_2728_79987",
    x1: 1128.83,
    y1: 538.227,
    x2: 1208.37,
    y2: 546.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_2728_79987",
    x1: 1129.86,
    y1: 535.897,
    x2: 1209.4,
    y2: 544.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_2728_79987",
    x1: 1130.89,
    y1: 533.566,
    x2: 1210.43,
    y2: 542.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_2728_79987",
    x1: 1131.92,
    y1: 531.235,
    x2: 1211.46,
    y2: 539.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_2728_79987",
    x1: 1132.95,
    y1: 528.904,
    x2: 1212.49,
    y2: 537.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_2728_79987",
    x1: 1133.98,
    y1: 526.573,
    x2: 1213.52,
    y2: 535.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_2728_79987",
    x1: 1135.01,
    y1: 524.243,
    x2: 1214.55,
    y2: 532.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_2728_79987",
    x1: 1136.04,
    y1: 521.912,
    x2: 1215.58,
    y2: 530.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_2728_79987",
    x1: 1137.07,
    y1: 519.582,
    x2: 1216.61,
    y2: 528.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_2728_79987",
    x1: 1138.1,
    y1: 517.251,
    x2: 1217.64,
    y2: 525.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_2728_79987",
    x1: 1139.13,
    y1: 514.92,
    x2: 1218.67,
    y2: 523.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_2728_79987",
    x1: 1140.16,
    y1: 512.59,
    x2: 1219.7,
    y2: 521.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_2728_79987",
    x1: 1141.19,
    y1: 510.259,
    x2: 1220.73,
    y2: 518.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_2728_79987",
    x1: 1142.22,
    y1: 507.929,
    x2: 1221.76,
    y2: 516.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_2728_79987",
    x1: 1143.25,
    y1: 505.598,
    x2: 1222.79,
    y2: 514.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_2728_79987",
    x1: 1144.29,
    y1: 503.267,
    x2: 1223.82,
    y2: 511.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint417_linear_2728_79987",
    x1: 1145.31,
    y1: 500.937,
    x2: 1224.85,
    y2: 509.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint418_linear_2728_79987",
    x1: 1146.35,
    y1: 498.606,
    x2: 1225.88,
    y2: 507.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint419_linear_2728_79987",
    x1: 1147.37,
    y1: 496.276,
    x2: 1226.91,
    y2: 504.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint420_linear_2728_79987",
    x1: 1148.41,
    y1: 493.944,
    x2: 1227.94,
    y2: 502.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint421_linear_2728_79987",
    x1: 1149.44,
    y1: 491.613,
    x2: 1228.97,
    y2: 500.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint422_linear_2728_79987",
    x1: 1150.47,
    y1: 489.283,
    x2: 1230,
    y2: 497.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint423_linear_2728_79987",
    x1: 1151.5,
    y1: 486.952,
    x2: 1231.03,
    y2: 495.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint424_linear_2728_79987",
    x1: 1152.53,
    y1: 484.622,
    x2: 1232.06,
    y2: 493.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint425_linear_2728_79987",
    x1: 1153.56,
    y1: 482.291,
    x2: 1233.09,
    y2: 490.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint426_linear_2728_79987",
    x1: 1154.59,
    y1: 479.96,
    x2: 1234.12,
    y2: 488.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint427_linear_2728_79987",
    x1: 1155.62,
    y1: 477.63,
    x2: 1235.15,
    y2: 486.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint428_linear_2728_79987",
    x1: 1156.65,
    y1: 475.299,
    x2: 1236.19,
    y2: 483.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint429_linear_2728_79987",
    x1: 1157.68,
    y1: 472.969,
    x2: 1237.22,
    y2: 481.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint430_linear_2728_79987",
    x1: 1158.71,
    y1: 470.638,
    x2: 1238.25,
    y2: 479.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint431_linear_2728_79987",
    x1: 1159.74,
    y1: 468.307,
    x2: 1239.28,
    y2: 476.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint432_linear_2728_79987",
    x1: 1160.77,
    y1: 465.977,
    x2: 1240.31,
    y2: 474.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint433_linear_2728_79987",
    x1: 1161.8,
    y1: 463.646,
    x2: 1241.34,
    y2: 472.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint434_linear_2728_79987",
    x1: 1162.83,
    y1: 461.316,
    x2: 1242.37,
    y2: 469.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint435_linear_2728_79987",
    x1: 1163.86,
    y1: 458.985,
    x2: 1243.4,
    y2: 467.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint436_linear_2728_79987",
    x1: 1164.89,
    y1: 456.653,
    x2: 1244.43,
    y2: 465.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint437_linear_2728_79987",
    x1: 1165.92,
    y1: 454.323,
    x2: 1245.46,
    y2: 462.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint438_linear_2728_79987",
    x1: 1166.95,
    y1: 451.992,
    x2: 1246.49,
    y2: 460.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint439_linear_2728_79987",
    x1: 1167.98,
    y1: 449.662,
    x2: 1247.52,
    y2: 458.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint440_linear_2728_79987",
    x1: 1169.01,
    y1: 447.331,
    x2: 1248.55,
    y2: 455.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint441_linear_2728_79987",
    x1: 1170.04,
    y1: 445,
    x2: 1249.58,
    y2: 453.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint442_linear_2728_79987",
    x1: 1171.07,
    y1: 442.67,
    x2: 1250.61,
    y2: 451.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint443_linear_2728_79987",
    x1: 1172.1,
    y1: 440.339,
    x2: 1251.64,
    y2: 448.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint444_linear_2728_79987",
    x1: 1173.13,
    y1: 438.009,
    x2: 1252.67,
    y2: 446.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint445_linear_2728_79987",
    x1: 1174.16,
    y1: 435.678,
    x2: 1253.7,
    y2: 444.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint446_linear_2728_79987",
    x1: 1175.19,
    y1: 433.347,
    x2: 1254.73,
    y2: 441.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint447_linear_2728_79987",
    x1: 1176.22,
    y1: 431.017,
    x2: 1255.76,
    y2: 439.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint448_linear_2728_79987",
    x1: 1177.25,
    y1: 428.686,
    x2: 1256.79,
    y2: 437.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint449_linear_2728_79987",
    x1: 1178.28,
    y1: 426.356,
    x2: 1257.82,
    y2: 434.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint450_linear_2728_79987",
    x1: 1179.31,
    y1: 424.025,
    x2: 1258.85,
    y2: 432.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint451_linear_2728_79987",
    x1: 1180.34,
    y1: 421.694,
    x2: 1259.88,
    y2: 430.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint452_linear_2728_79987",
    x1: 1181.37,
    y1: 419.363,
    x2: 1260.91,
    y2: 427.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint453_linear_2728_79987",
    x1: 1182.4,
    y1: 417.032,
    x2: 1261.94,
    y2: 425.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint454_linear_2728_79987",
    x1: 1183.43,
    y1: 414.702,
    x2: 1262.97,
    y2: 423.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint455_linear_2728_79987",
    x1: 1184.46,
    y1: 412.371,
    x2: 1264,
    y2: 420.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint456_linear_2728_79987",
    x1: 1185.49,
    y1: 410.04,
    x2: 1265.03,
    y2: 418.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint457_linear_2728_79987",
    x1: 1186.53,
    y1: 407.71,
    x2: 1266.06,
    y2: 416.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint458_linear_2728_79987",
    x1: 1187.55,
    y1: 405.379,
    x2: 1267.09,
    y2: 413.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint459_linear_2728_79987",
    x1: 1188.58,
    y1: 403.049,
    x2: 1268.12,
    y2: 411.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint460_linear_2728_79987",
    x1: 1189.62,
    y1: 400.718,
    x2: 1269.15,
    y2: 409.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint461_linear_2728_79987",
    x1: 1190.65,
    y1: 398.387,
    x2: 1270.18,
    y2: 406.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint462_linear_2728_79987",
    x1: 1191.68,
    y1: 396.057,
    x2: 1271.21,
    y2: 404.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint463_linear_2728_79987",
    x1: 1192.71,
    y1: 393.726,
    x2: 1272.24,
    y2: 402.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint464_linear_2728_79987",
    x1: 1193.74,
    y1: 391.396,
    x2: 1273.27,
    y2: 399.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint465_linear_2728_79987",
    x1: 1194.77,
    y1: 389.065,
    x2: 1274.3,
    y2: 397.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint466_linear_2728_79987",
    x1: 1195.8,
    y1: 386.734,
    x2: 1275.33,
    y2: 395.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint467_linear_2728_79987",
    x1: 1196.83,
    y1: 384.403,
    x2: 1276.36,
    y2: 392.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint468_linear_2728_79987",
    x1: 1197.86,
    y1: 382.072,
    x2: 1277.4,
    y2: 390.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint469_linear_2728_79987",
    x1: 1198.89,
    y1: 379.742,
    x2: 1278.43,
    y2: 388.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint470_linear_2728_79987",
    x1: 1199.92,
    y1: 377.411,
    x2: 1279.46,
    y2: 386.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint471_linear_2728_79987",
    x1: 1200.95,
    y1: 375.081,
    x2: 1280.49,
    y2: 383.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint472_linear_2728_79987",
    x1: 1201.98,
    y1: 372.75,
    x2: 1281.52,
    y2: 381.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint473_linear_2728_79987",
    x1: 1203.01,
    y1: 370.419,
    x2: 1282.55,
    y2: 379.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint474_linear_2728_79987",
    x1: 1204.04,
    y1: 368.089,
    x2: 1283.58,
    y2: 376.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint475_linear_2728_79987",
    x1: 1205.07,
    y1: 365.758,
    x2: 1284.61,
    y2: 374.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint476_linear_2728_79987",
    x1: 1206.1,
    y1: 363.428,
    x2: 1285.64,
    y2: 372.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint477_linear_2728_79987",
    x1: 1207.13,
    y1: 361.097,
    x2: 1286.67,
    y2: 369.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint478_linear_2728_79987",
    x1: 1208.16,
    y1: 358.766,
    x2: 1287.7,
    y2: 367.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint479_linear_2728_79987",
    x1: 1209.19,
    y1: 356.436,
    x2: 1288.73,
    y2: 365.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint480_linear_2728_79987",
    x1: 1210.22,
    y1: 354.105,
    x2: 1289.76,
    y2: 362.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint481_linear_2728_79987",
    x1: 1211.25,
    y1: 351.775,
    x2: 1290.79,
    y2: 360.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint482_linear_2728_79987",
    x1: 1212.28,
    y1: 349.444,
    x2: 1291.82,
    y2: 358.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint483_linear_2728_79987",
    x1: 1213.31,
    y1: 347.112,
    x2: 1292.85,
    y2: 355.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint484_linear_2728_79987",
    x1: 1214.34,
    y1: 344.782,
    x2: 1293.88,
    y2: 353.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint485_linear_2728_79987",
    x1: 1215.37,
    y1: 342.451,
    x2: 1294.91,
    y2: 351.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint486_linear_2728_79987",
    x1: 1216.4,
    y1: 340.121,
    x2: 1295.94,
    y2: 348.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint487_linear_2728_79987",
    x1: 1217.43,
    y1: 337.79,
    x2: 1296.97,
    y2: 346.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint488_linear_2728_79987",
    x1: 1218.46,
    y1: 335.459,
    x2: 1298,
    y2: 344.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint489_linear_2728_79987",
    x1: 1219.49,
    y1: 333.129,
    x2: 1299.03,
    y2: 341.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint490_linear_2728_79987",
    x1: 1220.52,
    y1: 330.798,
    x2: 1300.06,
    y2: 339.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint491_linear_2728_79987",
    x1: 1221.55,
    y1: 328.468,
    x2: 1301.09,
    y2: 337.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint492_linear_2728_79987",
    x1: 1222.58,
    y1: 326.137,
    x2: 1302.12,
    y2: 334.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint493_linear_2728_79987",
    x1: 1223.61,
    y1: 323.806,
    x2: 1303.15,
    y2: 332.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint494_linear_2728_79987",
    x1: 1224.64,
    y1: 321.476,
    x2: 1304.18,
    y2: 330.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint495_linear_2728_79987",
    x1: 1225.67,
    y1: 319.145,
    x2: 1305.21,
    y2: 327.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint496_linear_2728_79987",
    x1: 1226.7,
    y1: 316.815,
    x2: 1306.24,
    y2: 325.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint497_linear_2728_79987",
    x1: 1227.73,
    y1: 314.484,
    x2: 1307.27,
    y2: 323.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint498_linear_2728_79987",
    x1: 1228.76,
    y1: 312.152,
    x2: 1308.3,
    y2: 320.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint499_linear_2728_79987",
    x1: 1229.79,
    y1: 309.822,
    x2: 1309.33,
    y2: 318.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint500_linear_2728_79987",
    x1: 1230.83,
    y1: 307.491,
    x2: 1310.36,
    y2: 316.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint501_linear_2728_79987",
    x1: 1231.86,
    y1: 305.161,
    x2: 1311.39,
    y2: 313.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint502_linear_2728_79987",
    x1: 1232.89,
    y1: 302.83,
    x2: 1312.42,
    y2: 311.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59083,
    stopColor: "#A9CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/Bg2.61caa2bc1bb83cbe7c45c486f9e94805.svg";
export { ForwardRef as ReactComponent };